import React, {useState,useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

import HeaderUno from '../Metodos/Compartidos/HeaderUno';
import HeaderDos from '../Metodos/Compartidos/HeaderDos';

import { almacenarAnamnesisAction } from '../../actions/almacenarAnamnesisActions';
import {solicitarAnamnesisPdf} from '../../actions/generarAnamnesisPdfActions';

import useConfigAuth from '../../Hooks/useConfigAuth';
import {consultarLogoDocumentosAction} from '../../actions/logoDocumentosActions';

import AnamnesisEntrevista from './AnamnesisEntrevista';
import ModalAdendaAnamnesis from './ModalAdendaAnamnesis';
import {calcularAvanceAnamnesis} from './calcularAvanceAnamnesis';

//css
import {CuerpoCompleto, FlexColumn, FlexBox} from '../Css/StyledHeader.js';
import {
    Boton,
    BotonSmall,
    BotonPdf,
    Input,
    Select,
    Fondo,
    Margen,
    Label,
    InputSmall,
    ContenidoAnamnesis,
    FormularioAnamnesis,
    BarraAcciones,
    SubtituloFormulario
} from '../Css/StyledAnamnesis.js';

/*
====================================
NORMALIZAR FECHA PARA INPUT
====================================

La base puede devolver:

2014-01-01T00:00:00.000Z

El input date necesita:

2014-01-01
====================================
*/

const normalizarFechaInput = (valor) => {

    if (!valor) {
        return "";
    }


    const texto =
        String(valor);


    const coincidencia =
        texto.match(
            /^(\d{4}-\d{2}-\d{2})/
        );


    return coincidencia
        ? coincidencia[1]
        : "";

};

const Anamnesis = () => {

    const dispatch = useDispatch();

    const [config] = useConfigAuth();

    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const {medico_deriva, quien_vive, vivienda, cantidad_habitaciones, primera_consulta, fecha_primera_consulta, tratamientos_previos, tratamientos_previos_1_prof, tratamientos_previos_1_edad, tratamientos_previos_1_duracion_anios, tratamientos_previos_1_duracion_meses, tratamientos_previos_1_institucion, tratamientos_previos_1_datos_profesional, tratamientos_previos_2_prof, tratamientos_previos_2_edad, tratamientos_previos_2_duracion_anios, tratamientos_previos_2_duracion_meses, tratamientos_previos_2_institucion, tratamientos_previos_2_datos_profesional, tratamientos_previos_3_prof, tratamientos_previos_3_edad, tratamientos_previos_3_duracion_anios, tratamientos_previos_3_duracion_meses, tratamientos_previos_3_institucion, tratamientos_previos_3_datos_profesional, tratamientos_previos_4_prof, tratamientos_previos_4_edad, tratamientos_previos_4_duracion_anios, tratamientos_previos_4_duracion_meses, tratamientos_previos_4_institucion, tratamientos_previos_4_datos_profesional, tratamientos_previos_5_prof, tratamientos_previos_5_edad, tratamientos_previos_5_duracion_anios, tratamientos_previos_5_duracion_meses, tratamientos_previos_5_institucion, tratamientos_previos_5_datos_profesional, tratamientos_previos_6_prof, tratamientos_previos_6_edad, tratamientos_previos_6_duracion_anios, tratamientos_previos_6_duracion_meses, tratamientos_previos_6_institucion, tratamientos_previos_6_datos_profesional, tratamientos_previos_7_prof, tratamientos_previos_7_edad, tratamientos_previos_7_duracion_anios, tratamientos_previos_7_duracion_meses, tratamientos_previos_7_institucion, tratamientos_previos_7_datos_profesional, espaniol_materno, idioma_materno, bilingue, idioma_bilingue, estado_pareja, embarazo_buscado, embarazo_buscado_comentario, sexo_esperado_madre, sexo_esperado_padre, sintomas, enferm_acc_embarazo, abortos_antes_despues, cant_abortos, motivo_abortos, provocado_espontaneo, asfixia_perinatal, parto, parto_comentario, parto_semana, parto_duracion, apgar, peso, parto_complicacion, parto_complicacion_comentario, bebe_reaccion, bebe_complicacion, bebe_complicacion_coment, incubadora, incubadora_hs, incubadora_comentario, pecho, pecho_mes, pecho_comentario, pecho_prendio_comentario, bebe_lloron_comentario, chupete, chupete_mes, chupete_comentario, succion_pulgar, succion_pulgar_mes, succion_pulgar_comentario, uso_fular, uso_fular_hs, uso_fular_comentario, mamadera, mamadera_edad, mamadera_comentario, mamadera_solo_comentario, adaptacion_solido_comentario, dulce_salado_comentario, aceptar_alimentacion_comentario, rechazo_alimento_comentario, comer_solo_comentario, horarios_comida_comentario, primer_diente_comentario, diente_molestias_comentario, segunda_denticion_comentario, caida_dientes_comentario, cabeza_mes, cabeza_comentario, sento_mes, sento_comentario, gateo_mes, gateo_comentario, camino_mes, camino_comentario, mano, pie, habil, habil_comentario, aprend_esfin_anio, aprend_esfin_mes, aprend_esfin_comentario, reti_panial_dia_anio, reti_panial_dia_mes, reti_panial_dia_coment, reti_panial_noche_anio, reti_panial_noche_mes, reti_panial_noche_coment, ctr_esfin_dia_anio, ctr_esfin_dia_mes, ctr_esfin_dia_coment, ctr_esfin_noche_anio, ctr_esfin_noche_mes, ctr_esfin_noche_coment, ctr_esfin_reacc_padr_coment, esfin_solo, esfin_solo_anio, esfin_solo_comentario, bania_solo_comentario, viste_solo_comentario, enuresis, enuresis_comentario, encopresis, encopresis_comentario, prim_palab_mes, prim_palab_coment, leng_dific_coment, leng_coment, leng_entend_coment, dond_dorm_naci_coment, hizo_colecho, hmnos_colecho, hmnos_colecho_comentario, nuevo_miemb_comentario, donde_duerme_comentario, duerme_solo_anio, duerme_solo_mes, duerme_solo_comentario, duerme_hs, duerme_hs_comentario, duerme_act_comentario, duerme_luz, duerme_luz_comentario, duerme_juguete, duerme_juguete_cant, duerme_juguete_coment, acostar_tranq_coment, demora_dorm_coment, preg_sexual_coment, info_sexual_coment, tocar_genit_coment, tocar_genit_act_coment, enferm_coment, internado_coment, operado_coment, accidente_coment, perd_conocim_coment, conv_mar_des_coment, est_neurolog_coment, est_neurolog_diag_coment, tics_coment, unias_coment, guarderia, guarderia_edad, guarderia_coment, jardin, jardin_edad, jardin_coment, jardin_iniciacion_coment, jardin_adapt_coment, repitio_anio, repitio_anio_coment, docente_coment, trastaornos_coment, maestra_particular, maestra_particular_coment, amigos_coment, act_preferidas_coment, mudanza_coment, festeja_cumple_coment, vinculo_plaza_coment, relac_padre_coment, relac_madre_coment, relac_hmno_coment, relac_hmna_coment, relac_pareja_coment, etiquetas, etiquetas_coment, textura, textura_coment, sonido, sonido_coment, frio_calor, frio_calor_coment, terapia_madre, terapia_madre_coment, terapia_padre, terapia_padre_coment, orientacion_padres, orientacion_padres_cuando, orientacion_padres_coment, terapia_flia, terapia_flia_cuando, terapia_flia_coment, sustancias_toxicas, sustancias_toxicas_cuando, sustancias_toxicas_coment} = useSelector((state) => state.informacion.info_anamnesis);

    const [activo, setActivo] = useState('General');

    /*
    ====================================
    TIPO DE ANAMNESIS VISIBLE
    ====================================

    La estructurada y la semiestructurada
    se muestran como dos secciones
    independientes de la misma pantalla.
    ====================================
    */

    const [tipoAnamnesis, setTipoAnamnesis] =
        useState('estructurada');
    
    /*
    ====================================
    CONSERVAR ENTREVISTA EN PANTALLA
    ====================================

    Una vez que el profesional abre la
    semiestructurada, mantenemos montado
    su componente aunque cambie de sección.

    Así no pierde los cambios sin guardar.
    ====================================
    */

    const [semiestructuradaVisitada, setSemiestructuradaVisitada] =
        useState(false);

    /*
    ====================================
    ESTADO DE DESCARGA DEL PDF
    ====================================

    Evita solicitar el mismo PDF varias veces
    mientras se está generando.
    ====================================
    */

    const [descargandoPdf,setDescargandoPdf] = useState(false);

    // General
    const [medicoDeriva, setMedicoDeriva] = useState(medico_deriva);
    const [conQuienVive, setConQuienVive] = useState(quien_vive);
    const [infoVivienda, setInfoVivienda] = useState(vivienda);
    const [numeroHabitaciones, setNumeroHabitaciones] = useState(cantidad_habitaciones);
    const [primeraConsulta, setPrimeraConsulta] = useState(primera_consulta);
    const [primeraConsultaFecha,setPrimeraConsultaFecha] = useState(normalizarFechaInput(fecha_primera_consulta));
    const [tratamientosPrevios, setTratamientosPrevios] = useState(tratamientos_previos);
    const [tratamientosPrevios1, setTratamientosPrevios1] = useState(tratamientos_previos_1_prof);
    const [tratamientosPrevios1Edad, setTratamientosPrevios1Edad] = useState(tratamientos_previos_1_edad);
    const [tratamientosPrevios1DuracionAnios, setTratamientosPrevios1DuracionAnios] = useState(tratamientos_previos_1_duracion_anios);
    const [tratamientosPrevios1DuracionMeses, setTratamientosPrevios1DuracionMeses] = useState(tratamientos_previos_1_duracion_meses);
    const [tratamientosPrevios1Institucion, setTratamientosPrevios1Institucion] = useState(tratamientos_previos_1_institucion);
    const [tratamientosPrevios1Profesional, setTratamientosPrevios1Profesional] = useState(tratamientos_previos_1_datos_profesional);
    const [tratamientosPrevios2, setTratamientosPrevios2] = useState(tratamientos_previos_2_prof);
    const [tratamientosPrevios2Edad, setTratamientosPrevios2Edad] = useState(tratamientos_previos_2_edad);
    const [tratamientosPrevios2DuracionAnios, setTratamientosPrevios2DuracionAnios] = useState(tratamientos_previos_2_duracion_anios);
    const [tratamientosPrevios2DuracionMeses, setTratamientosPrevios2DuracionMeses] = useState(tratamientos_previos_2_duracion_meses);
    const [tratamientosPrevios2Institucion, setTratamientosPrevios2Institucion] = useState(tratamientos_previos_2_institucion);
    const [tratamientosPrevios2Profesional, setTratamientosPrevios2Profesional] = useState(tratamientos_previos_2_datos_profesional);
    const [tratamientosPrevios3, setTratamientosPrevios3] = useState(tratamientos_previos_3_prof);
    const [tratamientosPrevios3Edad, setTratamientosPrevios3Edad] = useState(tratamientos_previos_3_edad);
    const [tratamientosPrevios3DuracionAnios, setTratamientosPrevios3DuracionAnios] = useState(tratamientos_previos_3_duracion_anios);
    const [tratamientosPrevios3DuracionMeses, setTratamientosPrevios3DuracionMeses] = useState(tratamientos_previos_3_duracion_meses);
    const [tratamientosPrevios3Institucion, setTratamientosPrevios3Institucion] = useState(tratamientos_previos_3_institucion);
    const [tratamientosPrevios3Profesional, setTratamientosPrevios3Profesional] = useState(tratamientos_previos_3_datos_profesional);
    const [tratamientosPrevios4, setTratamientosPrevios4] = useState(tratamientos_previos_4_prof);
    const [tratamientosPrevios4Edad, setTratamientosPrevios4Edad] = useState(tratamientos_previos_4_edad);
    const [tratamientosPrevios4DuracionAnios, setTratamientosPrevios4DuracionAnios] = useState(tratamientos_previos_4_duracion_anios);
    const [tratamientosPrevios4DuracionMeses, setTratamientosPrevios4DuracionMeses] = useState(tratamientos_previos_4_duracion_meses);
    const [tratamientosPrevios4Institucion, setTratamientosPrevios4Institucion] = useState(tratamientos_previos_4_institucion);
    const [tratamientosPrevios4Profesional, setTratamientosPrevios4Profesional] = useState(tratamientos_previos_4_datos_profesional);
    const [tratamientosPrevios5, setTratamientosPrevios5] = useState(tratamientos_previos_5_prof);
    const [tratamientosPrevios5Edad, setTratamientosPrevios5Edad] = useState(tratamientos_previos_5_edad);
    const [tratamientosPrevios5DuracionAnios, setTratamientosPrevios5DuracionAnios] = useState(tratamientos_previos_5_duracion_anios);
    const [tratamientosPrevios5DuracionMeses, setTratamientosPrevios5DuracionMeses] = useState(tratamientos_previos_5_duracion_meses);
    const [tratamientosPrevios5Institucion, setTratamientosPrevios5Institucion] = useState(tratamientos_previos_5_institucion);
    const [tratamientosPrevios5Profesional, setTratamientosPrevios5Profesional] = useState(tratamientos_previos_5_datos_profesional);
    const [tratamientosPrevios6, setTratamientosPrevios6] = useState(tratamientos_previos_6_prof);
    const [tratamientosPrevios6Edad, setTratamientosPrevios6Edad] = useState(tratamientos_previos_6_edad);
    const [tratamientosPrevios6DuracionAnios, setTratamientosPrevios6DuracionAnios] = useState(tratamientos_previos_6_duracion_anios);
    const [tratamientosPrevios6DuracionMeses, setTratamientosPrevios6DuracionMeses] = useState(tratamientos_previos_6_duracion_meses);
    const [tratamientosPrevios6Institucion, setTratamientosPrevios6Institucion] = useState(tratamientos_previos_6_institucion);
    const [tratamientosPrevios6Profesional, setTratamientosPrevios6Profesional] = useState(tratamientos_previos_6_datos_profesional);
    const [tratamientosPrevios7, setTratamientosPrevios7] = useState(tratamientos_previos_7_prof);
    const [tratamientosPrevios7Edad, setTratamientosPrevios7Edad] = useState(tratamientos_previos_7_edad);
    const [tratamientosPrevios7DuracionAnios, setTratamientosPrevios7DuracionAnios] = useState(tratamientos_previos_7_duracion_anios);
    const [tratamientosPrevios7DuracionMeses, setTratamientosPrevios7DuracionMeses] = useState(tratamientos_previos_7_duracion_meses);
    const [tratamientosPrevios7Institucion, setTratamientosPrevios7Institucion] = useState(tratamientos_previos_7_institucion);
    const [tratamientosPrevios7Profesional, setTratamientosPrevios7Profesional] = useState(tratamientos_previos_7_datos_profesional);
    const [espaniolMaterno, setEspaniolMaterno] = useState(espaniol_materno);
    const [idiomaMaterno, setIdiomaMaterno] = useState(idioma_materno);
    const [infoBilingue, setInfoBilingue] = useState(bilingue);
    const [idiomaBilingue, setIdiomaBilingue] = useState(idioma_bilingue);
    //Embarazo
    const [estadoPareja, setEstadoPareja] = useState(estado_pareja);
    const [embarazoBuscado, setEmbarazoBuscado] = useState(embarazo_buscado);
    const [embarazoBuscadoComentario, setEmbarazoBuscadoComentario] = useState(embarazo_buscado_comentario);
    const [sexoEsperadoMadre, setSexoEsperadoMadre] = useState(sexo_esperado_madre);
    const [sexoEsperadoPadre, setSexoEsperadoPadre] = useState(sexo_esperado_padre);
    const [infoSintomas, setInfoSintomas] = useState(sintomas);
    const [enfermedadesAccidentesEmbarazo, setEnfermedadesAccidentesEmbarazo] = useState(enferm_acc_embarazo);
    const [abortosAntesDespues, setAbortosAntesDespues] = useState(abortos_antes_despues);
    const [cantidadAbortos, setCantidadAbortos] = useState(cant_abortos);
    const [motivoAbortos, setMotivoAbortos] = useState(motivo_abortos);
    const [provocadoEspontaneo, setProvocadoEspontaneo] = useState(provocado_espontaneo);
    const [asfixiaPerinatal, setAsfixiaPerinatal] = useState(asfixia_perinatal);
    //Parto
    const [infoParto, setInfoParto] = useState(parto);
    const [partoComentario, setPartoComentario] = useState(parto_comentario);
    const [partoSemana, setPartoSemana] = useState(parto_semana);
    const [partoDuracion, setPartoDuracion] = useState(parto_duracion);
    const [infoApgar, setInfoApgar] = useState(apgar);
    const [infoPeso, setInfoPeso] = useState(peso);
    const [partoComplicacion, setPartoComplicacion] = useState(parto_complicacion);
    const [partoComplicacionComentario, setPartoComplicacionComentario] = useState(parto_complicacion_comentario);
    const [bebeReaccion, setBebeReaccion] = useState(bebe_reaccion);
    const [bebeComplicacion, setBebeComplicacion] = useState(bebe_complicacion);
    const [bebeComplicacionComentario, setBebeComplicacionComentario] = useState(bebe_complicacion_coment);
    const [infoIncubadora, setInfoIncubadora] = useState(incubadora);
    const [incubadoraHoras, setIncubadoraHoras] = useState(incubadora_hs);
    const [incubadoraComentario, setIncubadoraComentario] = useState(incubadora_comentario);
    //Lactancia
    const [infoPecho, setInfoPecho] = useState(pecho);
    const [pechoMes, setPechoMes] = useState(pecho_mes);
    const [pechoComentario, setPechoComentario] = useState(pecho_comentario);
    const [pechoPrendioComentario, setPechoPrendioComentario] = useState(pecho_prendio_comentario);
    const [bebeLloronComentario, setBebeLloronComentario] = useState(bebe_lloron_comentario);
    const [infoChupete, setInfoChupete] = useState(chupete);
    const [chupeteMes, setChupeteMes] = useState(chupete_mes);
    const [chupeteComentario, setChupeteComentario] = useState(chupete_comentario);
    const [succionPulgar, setSuccionPulgar] = useState(succion_pulgar);
    const [succionPulgarMes, setSuccionPulgarMes] = useState(succion_pulgar_mes);
    const [succionPulgarComentario, setSuccionPulgarComentario] = useState(succion_pulgar_comentario);
    const [usoFular, setUsoFular] = useState(uso_fular);
    const [usoFularHoras, setUsoFularHoras] = useState(uso_fular_hs);
    const [usoFularComentario, setUsoFularComentario] = useState(uso_fular_comentario);
    //Alimentacion
    const [infoMamadera, setInfoMamadera] = useState(mamadera);
    const [mamaderaEdad, setMamaderaEdad] = useState(mamadera_edad);
    const [mamaderaComentario, setMamaderaComentario] = useState(mamadera_comentario);
    const [mamaderaSoloComentario, setMamaderaSoloComentario] = useState(mamadera_solo_comentario);
    const [adaptacionSolidoComentario, setAdaptacionSolidoComentario] = useState(adaptacion_solido_comentario);
    const [dulceSaladoComentario, setDulceSaladoComentario] = useState(dulce_salado_comentario);
    const [aceptarAlimentacionComentario, setAceptarAlimentacionComentario] = useState(aceptar_alimentacion_comentario);
    const [rechazoAlimentoComentario, setRechazoAlimentoComentario] = useState(rechazo_alimento_comentario);
    const [comerSoloComentario, setComerSoloComentario] = useState(comer_solo_comentario);
    const [horariosComidaComentario, setHorariosComidaComentario] = useState(horarios_comida_comentario);
    //Denticion
    const [primerDienteComentario, setPrimerDienteComentario] = useState(primer_diente_comentario);
    const [dienteMolestiasComentario, setDienteMolestiasComentario] = useState(diente_molestias_comentario);
    const [segundaDenticionComentario, setSegundaDenticionComentario] = useState(segunda_denticion_comentario);
    const [caidaDientesComentario, setCaidaDientesComentario] = useState(caida_dientes_comentario);
    //Motricidad
    const [cabezaMes, setCabezaMes] = useState(cabeza_mes);
    const [cabezaComentario, setCabezaComentario] = useState(cabeza_comentario);
    const [sentoMes, setSentoMes] = useState(sento_mes);
    const [sentoComentario, setSentoComentario] = useState(sento_comentario);
    const [gateoMes, setGateoMes] = useState(gateo_mes);
    const [gateoComentario, setGateoComentario] = useState(gateo_comentario);
    const [caminoMes, setCaminoMes] = useState(camino_mes);
    const [caminoComentario, setCaminoComentario] = useState(camino_comentario);
    const [infoMano, setInfoMano] = useState(mano);
    const [infoPie, setInfoPie] = useState(pie);
    const [infoHabil, setInfoHabil] = useState(habil);
    const [habilComentario, setHabilComentario] = useState(habil_comentario);
    //Control esfinteres
    const [aprendizajeEsfinteresAnio, setAprendizajeEsfinteresAnio] = useState(aprend_esfin_anio);
    const [aprendizajeEsfinteresMes, setAprendizajeEsfinteresMes] = useState(aprend_esfin_mes);
    const [aprendizajeEsfinteresComentario, setAprendizajeEsfinteresComentario] = useState(aprend_esfin_comentario);
    const [retiraronPanialesDiaAnio, setRetiraronPanialesDiaAnio] = useState(reti_panial_dia_anio);
    const [retiraronPanialesDiaMes, setRetiraronPanialesDiaMes] = useState(reti_panial_dia_mes);
    const [retiraronPanialesDiaComentario, setRetiraronPanialesDiaComentario] = useState(reti_panial_dia_coment);
    const [retiraronPanialesNocheAnio, setRetiraronPanialesNocheAnio] = useState(reti_panial_noche_anio);
    const [retiraronPanialesNocheMes, setRetiraronPanialesNocheMes] = useState(reti_panial_noche_mes);
    const [retiraronPanialesNocheComentario, setRetiraronPanialesNocheComentario] = useState(reti_panial_noche_coment);
    const [controlEsfinteresDiaAnio, setControlEsfinteresDiaAnio] = useState(ctr_esfin_dia_anio);
    const [controlEsfinteresDiaMes, setControlEsfinteresDiaMes] = useState(ctr_esfin_dia_mes);
    const [controlEsfinteresDiaComentario, setControlEsfinteresDiaComentario] = useState(ctr_esfin_dia_coment);
    const [controlEsfinteresNocheAnio, setControlEsfinteresNocheAnio] = useState(ctr_esfin_noche_anio);
    const [controlEsfinteresNocheMes, setControlEsfinteresNocheMes] = useState(ctr_esfin_noche_mes);
    const [controlEsfinteresNocheComentario, setControlEsfinteresNocheComentario] = useState(ctr_esfin_noche_coment);
    const [controlEsfinteresReaccionPadresComentario, setControlEsfinteresReaccionPadresComentario] = useState(ctr_esfin_reacc_padr_coment);
    const [esfinteresSolo, setEsfinteresSolo] = useState(esfin_solo);
    const [esfinteresSoloAnio, setEsfinteresSoloAnio] = useState(esfin_solo_anio);
    const [esfinteresSoloComentario, setEsfinteresSoloComentario] = useState(esfin_solo_comentario);
    const [baniaSoloComentario, setBaniaSoloComentario] = useState(bania_solo_comentario);
    const [visteSoloComentario, setVisteSoloComentario] = useState(viste_solo_comentario);
    const [infoEnuresis, setInfoEnuresis] = useState(enuresis);
    const [enuresisComentario, setEnuresisComentario] = useState(enuresis_comentario);
    const [infoEncopresis, setInfoEncopresis] = useState(encopresis);
    const [encopresisComentario, setEncopresisComentario] = useState(encopresis_comentario);
    //Lenguaje
    const [primerasPalabrasMes, setPrimerasPalabrasMes] = useState(prim_palab_mes);
    const [primerasPalabrasComentario, setPrimerasPalabrasComentario] = useState(prim_palab_coment);
    const [lenguajeDificultadComentario, setLenguajeDificultadComentario] = useState(leng_dific_coment);
    const [lenguajeComentario, setLenguajeComentario] = useState(leng_coment);
    const [lenguajeEntenderleComentario, setLenguajeEntenderleComentario] = useState(leng_entend_coment);
    //Sueño
    const [dondeDormiaAlNacerComentario, setDondeDormiaAlNacerComentario] = useState(dond_dorm_naci_coment);
    const [hizoColecho, setHizoColecho] = useState(hizo_colecho);
    const [hermanosColecho, setHermanosColecho] = useState(hmnos_colecho);
    const [hermanosColechoComentario, setHermanosColechoComentario] = useState(hmnos_colecho_comentario);
    const [nuevoMiembroComentario, setNuevoMiembroComentario] = useState(nuevo_miemb_comentario);
    const [dondeDuermeComentario, setDondeDuermeComentario] = useState(donde_duerme_comentario);
    const [duermeSoloAnio, setDuermeSoloAnio] = useState(duerme_solo_anio);
    const [duermeSoloMes, setDuermeSoloMes] = useState(duerme_solo_mes);
    const [duermeSoloComentario, setDuermeSoloComentario] = useState(duerme_solo_comentario);
    const [duermeHoras, setDuermeHoras] = useState(duerme_hs);
    const [duermeHorasComentario, setDuermeHorasComentario] = useState(duerme_hs_comentario);
    const [duermeActitudesComentario, setDuermeActitudesComentario] = useState(duerme_act_comentario);
    const [duermeLuz, setDuermeLuz] = useState(duerme_luz);
    const [duermeLuzComentario, setDuermeLuzComentario] = useState(duerme_luz_comentario);
    const [duermeJuguete, setDuermeJuguete] = useState(duerme_juguete);
    const [duermeJugueteCantidad, setDuermeJugueteCantidad] = useState(duerme_juguete_cant);
    const [duermeJugueteComentario, setDuermeJugueteComentario] = useState(duerme_juguete_coment);
    const [acostarseTranquiloComentario, setAcostarseTranquiloComentario] = useState(acostar_tranq_coment);
    const [demoraDormirseComentario, setDemoraDormirseComentario] = useState(demora_dorm_coment);
    const [preguntasSexualesComentario, setPreguntasSexualesComentario] = useState(preg_sexual_coment);
    const [informacionSexualComentario, setInformacionSexualComentario] = useState(info_sexual_coment);
    const [tocarGenitalesComentario, setTocarGenitalesComentario] = useState(tocar_genit_coment);
    const [tocarGenitalesActitudComentario, setTocarGenitalesActitudComentario] = useState(tocar_genit_act_coment);
    //Enfermedades
    const [enfermedadesComentario, setEnfermedadesComentario] = useState(enferm_coment);
    const [internadoComentario, setInternadoComentario] = useState(internado_coment);
    const [operadoComentario, setOperadoComentario] = useState(operado_coment);
    const [accidenteComentario, setAccidenteComentario] = useState(accidente_coment);
    const [perdidaConocimientoComentario, setPerdidaConocimientoComentario] = useState(perd_conocim_coment);
    const [convMarDesComentario, setConvMarDesComentario] = useState(conv_mar_des_coment);
    const [estudiosNeurologicosComentario, setEstudiosNeurologicosComentario] = useState(est_neurolog_coment);
    const [estudiosNeurologicosDiagnosticoComentario, setEstudiosNeurologicosDiagnosticoComentario] = useState(est_neurolog_diag_coment);
    const [ticsComentario, setTicsComentario] = useState(tics_coment);
    const [uniasComentario, setUniasComentario] = useState(unias_coment);
    //Escolaridad
    const [infoGuarderia, setInfoGuarderia] = useState(guarderia);
    const [guarderiaEdad, setGuarderiaEdad] = useState(guarderia_edad);
    const [guarderiaComentario, setGuarderiaComentario] = useState(guarderia_coment);
    const [infoJardin, setInfoJardin] = useState(jardin);
    const [jardinEdad, setJardinEdad] = useState(jardin_edad);
    const [jardinComentario, setJardinComentario] = useState(jardin_coment);
    const [jardinIniciacionComentario, setJardinIniciacionComentario] = useState(jardin_iniciacion_coment);
    const [jardinAdaptacionComentario, setJardinAdaptacionComentario] = useState(jardin_adapt_coment);
    const [repitioAnio, setRepitioAnio] = useState(repitio_anio);
    const [repitioAnioComentario, setRepitioAnioComentario] = useState(repitio_anio_coment);
    const [docenteComentario, setDocenteComentario] = useState(docente_coment);
    const [trastornosComentario, setTrastornosComentario] = useState(trastaornos_coment);
    const [maestraParticular, setMaestraParticular] = useState(maestra_particular);
    const [maestraParticularComentario, setMaestraParticularComentario] = useState(maestra_particular_coment);
    //Vida Social
    const [amigosComentario, setAmigosComentario] = useState(amigos_coment);
    const [actividadesPreferidasComentario, setActividadesPreferidasComentario] = useState(act_preferidas_coment);
    const [mudanzasComentario, setMudanzasComentario] = useState(mudanza_coment);
    const [festejaCumpleaniosComentario, setFestejaCumpleaniosComentario] = useState(festeja_cumple_coment);
    const [vinculaPlazaComentario, setVinculaPlazaComentario] = useState(vinculo_plaza_coment);
    //Relaciones Familiares
    const [relacionPadreComentario, setRelacionPadreComentario] = useState(relac_padre_coment);
    const [relacionMadreComentario, setRelacionMadreComentario] = useState(relac_madre_coment);
    const [relacionHermanoComentario, setRelacionHermanoComentario] = useState(relac_hmno_coment);
    const [relacionHermanaComentario, setRelacionHermanaComentario] = useState(relac_hmna_coment);
    const [relacionParejaComentario, setRelacionParejaComentario] = useState(relac_pareja_coment);
    //Sensopercepcion
    const [infoEtiquetas, setInfoEtiquetas] = useState(etiquetas);
    const [etiquetasComentario, setEtiquetasComentario] = useState(etiquetas_coment);
    const [infoTextura, setInfoTextura] = useState(textura);
    const [texturaComentario, setTexturaComentario] = useState(textura_coment);
    const [infoSonido, setInfoSonido] = useState(sonido);
    const [sonidoComentario, setSonidoComentario] = useState(sonido_coment);
    const [frioCalor, setFrioCalor] = useState(frio_calor);
    const [frioCalorComentario, setFrioCalorComentario] = useState(frio_calor_coment);
    //Terapias actuales/previas
    const [terapiaMadre, setTerapiaMadre] = useState(terapia_madre);
    const [terapiaMadreComentario, setTerapiaMadreComentario] = useState(terapia_madre_coment);
    const [terapiaPadre, setTerapiaPadre] = useState(terapia_padre);
    const [terapiaPadreComentario, setTerapiaPadreComentario] = useState(terapia_padre_coment);
    const [orientacionPadres, setOrientacionPadres] = useState(orientacion_padres);
    const [orientacionPadresCuando, setOrientacionPadresCuando] = useState(orientacion_padres_cuando);
    const [orientacionPadresComentario, setOrientacionPadresComentario] = useState(orientacion_padres_coment);
    const [terapiaFamiliar, setTerapiaFamiliar] = useState(terapia_flia);
    const [terapiaFamiliarCuando, setTerapiaFamiliarCuando] = useState(terapia_flia_cuando);
    const [terapiaFamiliarComentario, setTerapiaFamiliarComentario] = useState(terapia_flia_coment);
    const [sustanciasToxicas, setSustanciasToxicas] = useState(sustancias_toxicas);
    const [sustanciasToxicasCuando, setSustanciasToxicasCuando] = useState(sustancias_toxicas_cuando);
    const [sustanciasToxicasComentario, setSustanciasToxicasComentario] = useState(sustancias_toxicas_coment);

    /*
    ====================================
    MODAL DE ADENDA - ANAMNESIS ESTRUCTURADA
    ====================================

    Conservamos temporalmente los datos
    que el profesional intentó guardar.

    No se envían al backend hasta que
    confirme la adenda.
    ====================================
    */
    const [informacionPendiente, setInformacionPendiente] = useState(null);
    const [guardandoConAdenda, setGuardandoConAdenda] = useState(false);

    /*
    ====================================
    LIMPIAR TRATAMIENTOS PREVIOS
    ====================================

    Si el usuario indica que no hubo
    tratamientos previos, eliminamos todos
    los datos asociados a los 7 profesionales.

    Esto evita conservar información oculta
    y contradictoria en Redux y en la base.
    ====================================
    */

    const limpiarTratamientosPrevios = () => {

        setTratamientosPrevios1("");
        setTratamientosPrevios1Edad("");
        setTratamientosPrevios1DuracionAnios("");
        setTratamientosPrevios1DuracionMeses("");
        setTratamientosPrevios1Institucion("");
        setTratamientosPrevios1Profesional("");

        setTratamientosPrevios2("");
        setTratamientosPrevios2Edad("");
        setTratamientosPrevios2DuracionAnios("");
        setTratamientosPrevios2DuracionMeses("");
        setTratamientosPrevios2Institucion("");
        setTratamientosPrevios2Profesional("");

        setTratamientosPrevios3("");
        setTratamientosPrevios3Edad("");
        setTratamientosPrevios3DuracionAnios("");
        setTratamientosPrevios3DuracionMeses("");
        setTratamientosPrevios3Institucion("");
        setTratamientosPrevios3Profesional("");

        setTratamientosPrevios4("");
        setTratamientosPrevios4Edad("");
        setTratamientosPrevios4DuracionAnios("");
        setTratamientosPrevios4DuracionMeses("");
        setTratamientosPrevios4Institucion("");
        setTratamientosPrevios4Profesional("");

        setTratamientosPrevios5("");
        setTratamientosPrevios5Edad("");
        setTratamientosPrevios5DuracionAnios("");
        setTratamientosPrevios5DuracionMeses("");
        setTratamientosPrevios5Institucion("");
        setTratamientosPrevios5Profesional("");

        setTratamientosPrevios6("");
        setTratamientosPrevios6Edad("");
        setTratamientosPrevios6DuracionAnios("");
        setTratamientosPrevios6DuracionMeses("");
        setTratamientosPrevios6Institucion("");
        setTratamientosPrevios6Profesional("");

        setTratamientosPrevios7("");
        setTratamientosPrevios7Edad("");
        setTratamientosPrevios7DuracionAnios("");
        setTratamientosPrevios7DuracionMeses("");
        setTratamientosPrevios7Institucion("");
        setTratamientosPrevios7Profesional("");
    };

    /*
    ====================================
    LIMPIAR UN TRATAMIENTO PREVIO
    ====================================

    Si se elimina la especialidad de uno de
    los profesionales, limpiamos también
    todos sus datos dependientes.

    Así evitamos conservar información
    oculta de un tratamiento que ya no existe.
    ====================================
    */

    const limpiarTratamientoProfesional = (numero) => {

        switch (numero) {

            case 1:
                setTratamientosPrevios1Edad("");
                setTratamientosPrevios1DuracionAnios("");
                setTratamientosPrevios1DuracionMeses("");
                setTratamientosPrevios1Institucion("");
                setTratamientosPrevios1Profesional("");
                break;

            case 2:
                setTratamientosPrevios2Edad("");
                setTratamientosPrevios2DuracionAnios("");
                setTratamientosPrevios2DuracionMeses("");
                setTratamientosPrevios2Institucion("");
                setTratamientosPrevios2Profesional("");
                break;

            case 3:
                setTratamientosPrevios3Edad("");
                setTratamientosPrevios3DuracionAnios("");
                setTratamientosPrevios3DuracionMeses("");
                setTratamientosPrevios3Institucion("");
                setTratamientosPrevios3Profesional("");
                break;

            case 4:
                setTratamientosPrevios4Edad("");
                setTratamientosPrevios4DuracionAnios("");
                setTratamientosPrevios4DuracionMeses("");
                setTratamientosPrevios4Institucion("");
                setTratamientosPrevios4Profesional("");
                break;

            case 5:
                setTratamientosPrevios5Edad("");
                setTratamientosPrevios5DuracionAnios("");
                setTratamientosPrevios5DuracionMeses("");
                setTratamientosPrevios5Institucion("");
                setTratamientosPrevios5Profesional("");
                break;

            case 6:
                setTratamientosPrevios6Edad("");
                setTratamientosPrevios6DuracionAnios("");
                setTratamientosPrevios6DuracionMeses("");
                setTratamientosPrevios6Institucion("");
                setTratamientosPrevios6Profesional("");
                break;

            case 7:
                setTratamientosPrevios7Edad("");
                setTratamientosPrevios7DuracionAnios("");
                setTratamientosPrevios7DuracionMeses("");
                setTratamientosPrevios7Institucion("");
                setTratamientosPrevios7Profesional("");
                break;

            default:
                break;
        }
    };

    /*
    ====================================
    OBTENER VALORES ACTUALES
    ====================================

    Esta función construye exactamente el
    mismo payload que ya usa el guardado.

    También lo utilizaremos para calcular
    el avance sin tener que guardar.
    ====================================
    */

    const obtenerInformacionAnamnesis = () => ({
        config,
        payload: {
                "medico_deriva": medicoDeriva,
                "quien_vive": conQuienVive,
                "vivienda": infoVivienda,
                "cantidad_habitaciones": numeroHabitaciones,
                "primera_consulta": primeraConsulta,
                /*
                ====================================
                FECHA DE LA PRIMERA CONSULTA
                ====================================

                Si no se indicó una fecha, enviamos
                null en lugar de una cadena vacía.

                Así Sequelize no intenta convertir
                "" en una fecha inválida.
                ====================================
                */

                "fecha_primera_consulta":
                    primeraConsulta === "Si"
                        ? (primeraConsultaFecha || null)
                        : null,
                "tratamientos_previos": tratamientosPrevios,
                "tratamientos_previos_1_prof": tratamientosPrevios1,
                "tratamientos_previos_1_edad": tratamientosPrevios1Edad,
                "tratamientos_previos_1_duracion_anios": tratamientosPrevios1DuracionAnios,
                "tratamientos_previos_1_duracion_meses": tratamientosPrevios1DuracionMeses,
                "tratamientos_previos_1_institucion": tratamientosPrevios1Institucion,
                "tratamientos_previos_1_datos_profesional": tratamientosPrevios1Profesional,
                "tratamientos_previos_2_prof": tratamientosPrevios2,
                "tratamientos_previos_2_edad": tratamientosPrevios2Edad,
                "tratamientos_previos_2_duracion_anios": tratamientosPrevios2DuracionAnios,
                "tratamientos_previos_2_duracion_meses": tratamientosPrevios2DuracionMeses,
                "tratamientos_previos_2_institucion": tratamientosPrevios2Institucion,
                "tratamientos_previos_2_datos_profesional": tratamientosPrevios2Profesional,
                "tratamientos_previos_3_prof": tratamientosPrevios3,
                "tratamientos_previos_3_edad": tratamientosPrevios3Edad,
                "tratamientos_previos_3_duracion_anios": tratamientosPrevios3DuracionAnios,
                "tratamientos_previos_3_duracion_meses": tratamientosPrevios3DuracionMeses,
                "tratamientos_previos_3_institucion": tratamientosPrevios3Institucion,
                "tratamientos_previos_3_datos_profesional": tratamientosPrevios3Profesional,
                "tratamientos_previos_4_prof": tratamientosPrevios4,
                "tratamientos_previos_4_edad": tratamientosPrevios4Edad,
                "tratamientos_previos_4_duracion_anios": tratamientosPrevios4DuracionAnios,
                "tratamientos_previos_4_duracion_meses": tratamientosPrevios4DuracionMeses,
                "tratamientos_previos_4_institucion": tratamientosPrevios4Institucion,
                "tratamientos_previos_4_datos_profesional": tratamientosPrevios4Profesional,
                "tratamientos_previos_5_prof": tratamientosPrevios5,
                "tratamientos_previos_5_edad": tratamientosPrevios5Edad,
                "tratamientos_previos_5_duracion_anios": tratamientosPrevios5DuracionAnios,
                "tratamientos_previos_5_duracion_meses": tratamientosPrevios5DuracionMeses,
                "tratamientos_previos_5_institucion": tratamientosPrevios5Institucion,
                "tratamientos_previos_5_datos_profesional": tratamientosPrevios5Profesional,
                "tratamientos_previos_6_prof": tratamientosPrevios6,
                "tratamientos_previos_6_edad": tratamientosPrevios6Edad,
                "tratamientos_previos_6_duracion_anios": tratamientosPrevios6DuracionAnios,
                "tratamientos_previos_6_duracion_meses": tratamientosPrevios6DuracionMeses,
                "tratamientos_previos_6_institucion": tratamientosPrevios6Institucion,
                "tratamientos_previos_6_datos_profesional": tratamientosPrevios6Profesional,
                "tratamientos_previos_7_prof": tratamientosPrevios7,
                "tratamientos_previos_7_edad": tratamientosPrevios7Edad,
                "tratamientos_previos_7_duracion_anios": tratamientosPrevios7DuracionAnios,
                "tratamientos_previos_7_duracion_meses": tratamientosPrevios7DuracionMeses,
                "tratamientos_previos_7_institucion": tratamientosPrevios7Institucion,
                "tratamientos_previos_7_datos_profesional": tratamientosPrevios7Profesional,
                "espaniol_materno": espaniolMaterno,
                "idioma_materno": idiomaMaterno,
                "bilingue": infoBilingue,
                "idioma_bilingue": idiomaBilingue,
                "estado_pareja": estadoPareja,
                "embarazo_buscado": embarazoBuscado,
                "embarazo_buscado_comentario": embarazoBuscadoComentario,
                "sexo_esperado_madre": sexoEsperadoMadre,
                "sexo_esperado_padre": sexoEsperadoPadre,
                "sintomas": infoSintomas,
                "enferm_acc_embarazo": enfermedadesAccidentesEmbarazo,
                "abortos_antes_despues": abortosAntesDespues,
                "cant_abortos": cantidadAbortos,
                "motivo_abortos": motivoAbortos,
                "provocado_espontaneo": provocadoEspontaneo,
                "asfixia_perinatal": asfixiaPerinatal,
                "parto": infoParto,
                "parto_comentario": partoComentario,
                "parto_semana": partoSemana,
                "parto_duracion": partoDuracion,
                "apgar": infoApgar,
                "peso": infoPeso,
                "parto_complicacion": partoComplicacion,
                "parto_complicacion_comentario": partoComplicacionComentario,
                "bebe_reaccion": bebeReaccion,
                "bebe_complicacion": bebeComplicacion,
                "bebe_complicacion_coment": bebeComplicacionComentario,
                "incubadora": infoIncubadora,
                "incubadora_hs": incubadoraHoras,
                "incubadora_comentario": incubadoraComentario,
                "pecho": infoPecho,
                "pecho_mes": pechoMes,
                "pecho_comentario": pechoComentario,
                "pecho_prendio_comentario": pechoPrendioComentario,
                "bebe_lloron_comentario": bebeLloronComentario,
                "chupete": infoChupete,
                "chupete_mes": chupeteMes,
                "chupete_comentario": chupeteComentario,
                "succion_pulgar": succionPulgar,
                "succion_pulgar_mes": succionPulgarMes,
                "succion_pulgar_comentario": succionPulgarComentario,
                "uso_fular": usoFular,
                "uso_fular_hs": usoFularHoras,
                "uso_fular_comentario": usoFularComentario,
                "mamadera": infoMamadera,
                "mamadera_edad": mamaderaEdad,
                "mamadera_comentario": mamaderaComentario,
                "mamadera_solo_comentario": mamaderaSoloComentario,
                "adaptacion_solido_comentario": adaptacionSolidoComentario,
                "dulce_salado_comentario": dulceSaladoComentario,
                "aceptar_alimentacion_comentario": aceptarAlimentacionComentario,
                "rechazo_alimento_comentario": rechazoAlimentoComentario,
                "comer_solo_comentario": comerSoloComentario,
                "horarios_comida_comentario": horariosComidaComentario,
                "primer_diente_comentario": primerDienteComentario,
                "diente_molestias_comentario": dienteMolestiasComentario,
                "segunda_denticion_comentario": segundaDenticionComentario,
                "caida_dientes_comentario": caidaDientesComentario,
                "cabeza_mes": cabezaMes,
                "cabeza_comentario": cabezaComentario,
                "sento_mes": sentoMes,
                "sento_comentario": sentoComentario,
                "gateo_mes": gateoMes,
                "gateo_comentario": gateoComentario,
                "camino_mes": caminoMes,
                "camino_comentario": caminoComentario,
                "mano": infoMano,
                "pie": infoPie,
                "habil": infoHabil,
                "habil_comentario": habilComentario,
                "aprend_esfin_anio": aprendizajeEsfinteresAnio,
                "aprend_esfin_mes": aprendizajeEsfinteresMes,
                "aprend_esfin_comentario": aprendizajeEsfinteresComentario,
                "reti_panial_dia_anio": retiraronPanialesDiaAnio,
                "reti_panial_dia_mes": retiraronPanialesDiaMes,
                "reti_panial_dia_coment": retiraronPanialesDiaComentario,
                "reti_panial_noche_anio": retiraronPanialesNocheAnio,
                "reti_panial_noche_mes": retiraronPanialesNocheMes,
                "reti_panial_noche_coment": retiraronPanialesNocheComentario,
                "ctr_esfin_dia_anio": controlEsfinteresDiaAnio,
                "ctr_esfin_dia_mes": controlEsfinteresDiaMes,
                "ctr_esfin_dia_coment": controlEsfinteresDiaComentario,
                "ctr_esfin_noche_anio": controlEsfinteresNocheAnio,
                "ctr_esfin_noche_mes": controlEsfinteresNocheMes,
                "ctr_esfin_noche_coment": controlEsfinteresNocheComentario,
                "ctr_esfin_reacc_padr_coment": controlEsfinteresReaccionPadresComentario,
                "esfin_solo": esfinteresSolo,
                "esfin_solo_anio": esfinteresSoloAnio,
                "esfin_solo_comentario": esfinteresSoloComentario,
                "bania_solo_comentario": baniaSoloComentario,
                "viste_solo_comentario": visteSoloComentario,
                "enuresis": infoEnuresis,
                "enuresis_comentario": enuresisComentario,
                "encopresis": infoEncopresis,
                "encopresis_comentario": encopresisComentario,
                "prim_palab_mes": primerasPalabrasMes,
                "prim_palab_coment": primerasPalabrasComentario,
                "leng_dific_coment": lenguajeDificultadComentario,
                "leng_coment": lenguajeComentario,
                "leng_entend_coment": lenguajeEntenderleComentario,
                "dond_dorm_naci_coment": dondeDormiaAlNacerComentario,
                "hizo_colecho": hizoColecho,
                "hmnos_colecho": hermanosColecho,
                "hmnos_colecho_comentario": hermanosColechoComentario,
                "nuevo_miemb_comentario": nuevoMiembroComentario,
                "donde_duerme_comentario": dondeDuermeComentario,
                "duerme_solo_anio": duermeSoloAnio,
                "duerme_solo_mes": duermeSoloMes,
                "duerme_solo_comentario": duermeSoloComentario,
                "duerme_hs": duermeHoras,
                "duerme_hs_comentario": duermeHorasComentario,
                "duerme_act_comentario": duermeActitudesComentario,
                "duerme_luz": duermeLuz,
                "duerme_luz_comentario": duermeLuzComentario,
                "duerme_juguete": duermeJuguete,
                "duerme_juguete_cant": duermeJugueteCantidad,
                "duerme_juguete_coment": duermeJugueteComentario,
                "acostar_tranq_coment": acostarseTranquiloComentario,
                "demora_dorm_coment": demoraDormirseComentario,
                "preg_sexual_coment": preguntasSexualesComentario,
                "info_sexual_coment": informacionSexualComentario,
                "tocar_genit_coment": tocarGenitalesComentario,
                "tocar_genit_act_coment": tocarGenitalesActitudComentario,
                "enferm_coment": enfermedadesComentario,
                "internado_coment": internadoComentario,
                "operado_coment": operadoComentario,
                "accidente_coment": accidenteComentario,
                "perd_conocim_coment": perdidaConocimientoComentario,
                "conv_mar_des_coment": convMarDesComentario,
                "est_neurolog_coment": estudiosNeurologicosComentario,
                "est_neurolog_diag_coment": estudiosNeurologicosDiagnosticoComentario,
                "tics_coment": ticsComentario,
                "unias_coment": uniasComentario,
                "guarderia": infoGuarderia,
                "guarderia_edad": guarderiaEdad,
                "guarderia_coment": guarderiaComentario,
                "jardin": infoJardin,
                "jardin_edad": jardinEdad,
                "jardin_coment": jardinComentario,
                "jardin_iniciacion_coment": jardinIniciacionComentario,
                "jardin_adapt_coment": jardinAdaptacionComentario,
                "repitio_anio": repitioAnio,
                "repitio_anio_coment": repitioAnioComentario,
                "docente_coment": docenteComentario,
                "trastaornos_coment": trastornosComentario,
                "maestra_particular": maestraParticular,
                "maestra_particular_coment": maestraParticularComentario,
                "amigos_coment": amigosComentario,
                "act_preferidas_coment": actividadesPreferidasComentario,
                "mudanza_coment": mudanzasComentario,
                "festeja_cumple_coment": festejaCumpleaniosComentario,
                "vinculo_plaza_coment": vinculaPlazaComentario,
                "relac_padre_coment": relacionPadreComentario,
                "relac_madre_coment": relacionMadreComentario,
                "relac_hmno_coment": relacionHermanoComentario,
                "relac_hmna_coment": relacionHermanaComentario,
                "relac_pareja_coment": relacionParejaComentario,
                "etiquetas": infoEtiquetas,
                "etiquetas_coment": etiquetasComentario,
                "textura": infoTextura,
                "textura_coment": texturaComentario,
                "sonido": infoSonido,
                "sonido_coment": sonidoComentario,
                "frio_calor": frioCalor,
                "frio_calor_coment": frioCalorComentario,
                "terapia_madre": terapiaMadre,
                "terapia_madre_coment": terapiaMadreComentario,
                "terapia_padre": terapiaPadre,
                "terapia_padre_coment": terapiaPadreComentario,
                "orientacion_padres": orientacionPadres,
                "orientacion_padres_cuando": orientacionPadresCuando,
                "orientacion_padres_coment": orientacionPadresComentario,
                "terapia_flia": terapiaFamiliar,
                "terapia_flia_cuando": terapiaFamiliarCuando,
                "terapia_flia_coment": terapiaFamiliarComentario,
                "sustancias_toxicas": sustanciasToxicas,
                "sustancias_toxicas_cuando": sustanciasToxicasCuando,
                "sustancias_toxicas_coment": sustanciasToxicasComentario,
                "id_paciente": id_paciente
        }

    });


    /*
    ====================================
    AVANCE ACTUAL DEL FORMULARIO
    ====================================

    React vuelve a calcularlo cuando cambia
    cualquiera de los estados de las respuestas.
    ====================================
    */

    const avanceAnamnesis = calcularAvanceAnamnesis(
        obtenerInformacionAnamnesis().payload
    );

    
    /*
    ====================================
    AYUDA: GUARDADO Y ADENDAS
    ====================================

    El mismo botón explica el funcionamiento
    de ambas partes de la Anamnesis.

    No modifica las respuestas ni inicia
    una petición al backend.
    ====================================
    */

    const handleAbrirAyudaAnamnesis = async () => {

    await Swal.fire({

        title: '¿Cómo funciona la Anamnesis?',

        width: 650,

        icon: 'info',

        /*
        Achicamos únicamente el ícono de
        información de este tutorial.
        */

        didOpen: (popup) => {

            const icono = popup.querySelector(
                '.swal2-icon'
            );

            if (icono) {
                icono.style.transform = 'scale(0.6)';
                icono.style.margin = '0 auto 5px';
            }

        },

            html: `
                <div
                    style="
                        text-align: left;
                        font-size: 0.85rem;
                        line-height: 1.55;
                        color: #3F4B4B;
                    "
                >

                    <div style="margin-bottom: 12px;">

                        <strong>
                            Dos partes independientes
                        </strong>

                        <br>

                        La Anamnesis estructurada y la
                        entrevista semiestructurada
                        se guardan por separado.

                        Cada una tiene su propio plazo
                        de 24 horas, que comienza con
                        su primer guardado.

                    </div>


                    <div style="margin-bottom: 12px;">

                        <strong>
                            Durante las primeras 24 horas
                        </strong>

                        <br>

                        Podés modificar y volver a
                        guardar el documento sin tener
                        que registrar una adenda.

                    </div>


                    <div style="margin-bottom: 12px;">

                        <strong>
                            Después de las 24 horas
                        </strong>

                        <br>

                        Podés seguir modificando el
                        documento. Cuando presiones
                        Guardar, el sistema te pedirá
                        confirmar el registro de
                        una adenda.

                    </div>


                    <div style="margin-bottom: 12px;">

                        <strong>
                            ¿Es obligatorio completar
                            los campos de la adenda?
                        </strong>

                        <br>

                        No. Podés completar todos,
                        algunos o ninguno.

                        Si guardás sin detallar los
                        cambios, quedará registrada
                        una constancia de que guardaste
                        una nueva versión sin
                        especificar qué modificaste.

                    </div>


                    <div style="margin-bottom: 12px;">

                        <strong>
                            ¿Qué pasa si cancelás?
                        </strong>

                        <br>

                        Los cambios permanecen en
                        pantalla, pero no se guardan.
                        Podés volver a presionar
                        Guardar cuando quieras
                        confirmar la modificación.

                    </div>


                    <div style="margin-bottom: 12px;">

                        <strong>
                            ¿Qué incluye el PDF?
                        </strong>

                        <br>

                        El PDF se genera con la
                        información guardada e incluye
                        las adendas de cada documento
                        en su sección correspondiente.

                        Si tenés cambios sin guardar,
                        primero tenés que guardarlos
                        para que aparezcan en el PDF.

                    </div>


                    <div
                        style="
                            padding: 12px;
                            border-radius: 8px;
                            background-color: #F3F8F8;
                            border-left: 3px solid #23AAAF;
                        "
                    >

                        <strong>
                            Sobre el porcentaje de avance
                        </strong>

                        <br><br>

                        El porcentaje de la parte
                        estructurada indica cuántas
                        preguntas tienen respuesta
                        en pantalla.

                        No significa que esas respuestas
                        ya estén guardadas.

                    </div>

                </div>
            `,

            confirmButtonText: 'Entendido',

            confirmButtonColor: '#23AAAF'

        });

    };

    /*
    ====================================
    GUARDAR ANAMNESIS
    ====================================
    */

    const guardarAnamnesis = async (e) => {

        e.preventDefault();

        if (informacionPendiente) {
            return;
        }

        const informacion =
            obtenerInformacionAnamnesis();


        /*
        ====================================
        INTENTAR GUARDAR LA ANAMNESIS
        ====================================

        Si el plazo de 24 horas no venció,
        el backend guarda normalmente.

        Si venció, devuelve
        requiere_adenda: true.
        ====================================
        */

        const resultado = await dispatch(
            almacenarAnamnesisAction(informacion)
        );


        /*
        ====================================
        ABRIR EL MODAL SI SE REQUIERE ADENDA
        ====================================

        Conservamos el payload original
        para enviarlo nuevamente cuando
        el profesional confirme la adenda.
        ====================================
        */

        if (resultado?.requiere_adenda) {

            setInformacionPendiente(
                informacion
            );

        }

    };

    /*
    ====================================
    CANCELAR ADENDA
    ====================================

    Cerramos el modal sin enviar nada.

    Los cambios que el profesional escribió
    permanecen en los campos del formulario.
    ====================================
    */

    const cancelarAdenda = () => {

        if (guardandoConAdenda) {
            return;
        }

        setInformacionPendiente(null);

    };


    /*
    ====================================
    CONFIRMAR ADENDA Y GUARDAR ANAMNESIS
    ====================================

    Enviamos los mismos datos que el
    profesional intentó guardar, agregando
    el objeto adenda que completó en el modal.

    El backend guarda la Anamnesis y
    la adenda dentro de una transacción.
    ====================================
    */

    const confirmarAdenda = async (adenda) => {

        if (
            !informacionPendiente ||
            guardandoConAdenda
        ) {
            return;
        }


        /*
        Evitamos guardar información si el
        profesional cambió de paciente mientras
        el modal estaba abierto.
        */

        if (
            informacionPendiente.payload.id_paciente !==
            id_paciente
        ) {

            setInformacionPendiente(null);

            return;

        }


        setGuardandoConAdenda(true);


        try {

            const resultado = await dispatch(
                almacenarAnamnesisAction({

                    config: informacionPendiente.config,

                    payload: {

                        ...informacionPendiente.payload,

                        adenda

                    }

                })
            );


            /*
            Cerramos el modal solamente si
            el backend confirmó el guardado.

            Ante un error, el modal permanece
            abierto para que no se pierda
            el texto de la adenda.
            */

            if (resultado?.ok) {

                setInformacionPendiente(null);

            }

        } finally {

            setGuardandoConAdenda(false);

        }

    };

    /*
    ====================================
    ESTADO DEL LOGO PARA EL PDF
    ====================================
    */

    const logoConfigurado = useSelector(
        state => state.usuario.logo_documentos_configurado
    );

    const logoCargado = useSelector(
        state => state.usuario.logo_documentos_cargado
    );

    const consultaLogoRealizadaRef = useRef(false);


    /*
    ====================================
    CONSULTAR ESTADO DEL LOGO
    ====================================
    */

    useEffect(() => {

        if (
            !config ||
            logoCargado ||
            consultaLogoRealizadaRef.current
        ) {
            return;
        }

        consultaLogoRealizadaRef.current = true;

        dispatch(
            consultarLogoDocumentosAction({config})
        );

    }, [config, logoCargado, dispatch]);

    /*
    ====================================
    ABRIR / CERRAR SECCIONES
    ====================================

    Cuando abrimos una sección:

    1. cerramos la anterior,
    2. abrimos la nueva,
    3. esperamos a que React actualice el DOM,
    4. llevamos el scroll al encabezado de
    la sección que el usuario eligió.

    Así no queda parado en el final de la
    sección nueva cuando la sección anterior
    era muy extensa.
    ====================================
    */

    const manejarActivo = (
        e,
        tipo
    ) => {

        e.preventDefault();


        const boton =
            e.currentTarget;


        const seVaAAbrir =
            activo !== tipo;


        setActivo(
            seVaAAbrir
                ? tipo
                : ""
        );


        if (seVaAAbrir) {

            setTimeout(
                () => {

                    boton.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });

                },
                80
            );

        }

    };

    /*
    ====================================
    DESCARGAR PDF DE ANAMNESIS
    ====================================

    1. Solicita el PDF al backend.
    2. Recibe el archivo como Blob.
    3. Crea una URL temporal en el navegador.
    4. Descarga el archivo.
    5. Libera la URL temporal.

    IMPORTANTE:
    El PDF contiene los datos que ya están
    guardados en la base de datos.
    ====================================
    */

    const descargarAnamnesisPdf = async () => {

        if (descargandoPdf) {
            return;
        }

        if (!id_paciente) {
            alert('No hay un paciente seleccionado.');
            return;
        }

        setDescargandoPdf(true);

        try {

            const archivo = await solicitarAnamnesisPdf({
                config,
                id_paciente
            });

            /*
            Axios puede recibir un JSON de error
            como Blob si la petición utiliza
            responseType: 'blob'.

            Evitamos descargar ese error como
            si fuera un archivo PDF.
            */

            if (
                archivo.type &&
                archivo.type.includes('application/json')
            ) {

                const texto = await archivo.text();

                let mensaje =
                    'No se pudo generar el PDF.';

                try {
                    const error = JSON.parse(texto);

                    mensaje =
                        error.msg ||
                        error.message ||
                        mensaje;
                } catch (e) {
                    // Conservamos el mensaje genérico.
                }

                throw new Error(mensaje);
            }

            const pdf = new Blob(
                [archivo],
                {
                    type: 'application/pdf'
                }
            );

            const urlTemporal =
                window.URL.createObjectURL(pdf);

            const enlace =
                document.createElement('a');

            enlace.href = urlTemporal;

            enlace.download =
                `anamnesis_${id_paciente}.pdf`;

            document.body.appendChild(enlace);

            enlace.click();

            enlace.remove();

            /*
            Dejamos un pequeño margen antes de
            liberar la URL para que el navegador
            pueda iniciar la descarga.
            */

            window.setTimeout(() => {
                window.URL.revokeObjectURL(
                    urlTemporal
                );
            }, 1000);

        } catch (error) {

            console.error(
                'Error al descargar Anamnesis:',
                error
            );

            /*
            Si el backend devolvió un error con
            responseType blob, intentamos leer
            el mensaje antes de mostrarlo.
            */

            let mensaje =
                error.message ||
                'No se pudo generar el PDF.';

            const datosError =
                error.response?.data;

            if (datosError instanceof Blob) {

                try {

                    const texto =
                        await datosError.text();

                    const respuestaError =
                        JSON.parse(texto);

                    mensaje =
                        respuestaError.msg ||
                        respuestaError.message ||
                        mensaje;

                } catch (e) {
                    // Mantenemos el mensaje disponible.
                }

            }

            alert(mensaje);

        } finally {

            setDescargandoPdf(false);

        }

    };

    return ( 
        <CuerpoCompleto height="auto">

            <HeaderUno />

            <HeaderDos
                link={`/escritorio/pacientes/paciente`}
                componente={"Anamnesis"}
                paciente={true}
            />

            <ContenidoAnamnesis>

                {/* =====================================
                    SELECTOR DE TIPO DE ANAMNESIS
                    DISEÑO CON PESTAÑAS REDONDEADAS
                ====================================== */}

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '16px',
                        marginBottom: '5px',
                    }}
                >

                    {/* CONTENEDOR DE LAS DOS PESTAÑAS */}

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '4px',
                            background: '#F1F1EE',
                            borderRadius: '30px'
                        }}
                    >

                        {/* ESTRUCTURADA */}

                        <button
                            type="button"
                            aria-pressed={
                                tipoAnamnesis === 'estructurada'
                            }
                            onClick={() =>
                                setTipoAnamnesis('estructurada')
                            }
                            style={{
                                border: 'none',
                                borderRadius: '25px',
                                padding: '10px 18px',
                                background:
                                    tipoAnamnesis === 'estructurada'
                                        ? '#147B82'
                                        : 'transparent',
                                color:
                                    tipoAnamnesis === 'estructurada'
                                        ? '#FFFFFF'
                                        : '#535353',
                                fontSize: '13px',
                                fontWeight:
                                    tipoAnamnesis === 'estructurada'
                                        ? 700
                                        : 500,
                                cursor: 'pointer',
                                whiteSpace: 'nowrap'
                            }}
                                >
                                    Estructurada

                                    {/* CONTADOR DE PREGUNTAS RESPONDIDAS */}

                                    <span
                                        style={{
                                            marginLeft: '8px',
                                            padding: '2px 7px',
                                            borderRadius: '12px',
                                            background: 'rgba(255,255,255,0.25)',
                                            fontSize: '11px',
                                            fontWeight: 700
                                        }}
                                    >
                                        {avanceAnamnesis.respondidas}/{avanceAnamnesis.total}
                                    </span>

                                </button>


                                {/* SEMIESTRUCTURADA */}

                        <button
                            type="button"
                            aria-pressed={
                                tipoAnamnesis === 'semiestructurada'
                            }
                            onClick={() => {

                                /*
                                Mantenemos montada la entrevista
                                para no perder los cambios
                                cuando se cambia de sección.
                                */

                                setSemiestructuradaVisitada(true);

                                setTipoAnamnesis(
                                    'semiestructurada'
                                );

                            }}
                            style={{
                                border: 'none',
                                borderRadius: '25px',
                                padding: '10px 18px',
                                background:
                                    tipoAnamnesis === 'semiestructurada'
                                        ? '#147B82'
                                        : 'transparent',
                                color:
                                    tipoAnamnesis === 'semiestructurada'
                                        ? '#FFFFFF'
                                        : '#535353',
                                fontSize: '13px',
                                fontWeight:
                                    tipoAnamnesis === 'semiestructurada'
                                        ? 700
                                        : 500,
                                cursor: 'pointer',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Semiestructurada
                        </button>

                    </div>


                    {/* =====================================
                        AYUDA SOBRE GUARDADO Y ADENDAS
                    ======================================

                        Un solo botón de ayuda para
                        las dos partes de la Anamnesis.

                        Conserva el aspecto del botón
                        utilizado en Estadísticas
                        y Cobros.
                    ====================================== */}

                    <button
                        type="button"

                        onClick={
                            handleAbrirAyudaAnamnesis
                        }

                        aria-label={
                            'Ver explicación sobre el guardado de la Anamnesis'
                        }

                        title={
                            '¿Cómo funciona el guardado?'
                        }

                        style={{
                            width: '22px',
                            height: '22px',

                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',

                            flexShrink: 0,

                            padding: 0,

                            border: '1px solid #BFC9C9',
                            borderRadius: '50%',

                            backgroundColor: '#FFFFFF',

                            color: '#646464',

                            fontFamily: 'Montserrat, sans-serif',
                            fontSize: '0.7rem',
                            fontWeight: 700,

                            cursor: 'pointer',

                            transition: 'all 0.15s ease'
                        }}

                        onMouseEnter={e => {
                            e.currentTarget.style.borderColor =
                                '#23AAAF';

                            e.currentTarget.style.color =
                                '#23AAAF';
                        }}

                        onMouseLeave={e => {
                            e.currentTarget.style.borderColor =
                                '#BFC9C9';

                            e.currentTarget.style.color =
                                '#646464';
                        }}
                    >
                        ?
                    </button>


                    {/* =====================================
                        AVANCE GENERAL DE LA ESTRUCTURADA
                    ====================================== */}

                    {
                        tipoAnamnesis === 'estructurada' && (

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                }}
                            >

                                <span
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: 700,
                                        color: '#646464',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {avanceAnamnesis.porcentaje}% completo
                                </span>

                                <div
                                    style={{
                                        width: '90px',
                                        height: '6px',
                                        borderRadius: '6px',
                                        overflow: 'hidden',
                                        background: '#EDEDE9'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: `${avanceAnamnesis.porcentaje}%`,
                                            height: '100%',
                                            borderRadius: '6px',
                                            background: '#0E7A7E',
                                            transition: 'width 0.2s ease'
                                        }}
                                    />
                                </div>

                            </div>

                        )
                    }

                </div>


                {/* =====================================
                    ANAMNESIS ESTRUCTURADA
                ====================================== */}

                <FormularioAnamnesis
                    onSubmit={guardarAnamnesis}
                    style={{
                        display:
                            tipoAnamnesis === 'estructurada'
                                ? undefined
                                : 'none'
                    }}
                >
                    <Fondo> 
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.General.respondidas}/${avanceAnamnesis.secciones.General.total}`}
                            onClick={(e) => manejarActivo(e, "General")}
                        >
                            General
                        </Boton>
                    </div>
                    <div>{activo === "General" ? 
                        <Margen> 
                            <FlexBox> 
                                <Label htmlFor="text">Médico quien deriva</Label>
                                <Input
                                    type="text"
                                    name="medicoDeriva"
                                    placeholder="Médico quien deriva"
                                    value={medicoDeriva || ""}
                                    onChange={e => setMedicoDeriva(e.target.value)}
                                />
                            </FlexBox>
                            <FlexBox>
                                <Label htmlFor="text">Con quien vive el niño o adolescente</Label>
                                <Input
                                    type="text"
                                    name="conQuienVive"
                                    placeholder="Con quien vive"
                                    value={conQuienVive || ""}
                                    onChange={e => setConQuienVive(e.target.value)}
                                />
                            </FlexBox>
                            <FlexBox>
                            <Label>Vivienda</Label>
                                <Select value={infoVivienda || ""} onChange={e => setInfoVivienda(e.target.value)}>
                                    <option></option>
                                    <option>Casa</option>
                                    <option>Departamento</option>
                                    <option>Ph</option>
                                </Select>
                            </FlexBox>
                            <FlexBox>
                            <Label>Número de habitaciones</Label>
                                <Select value={numeroHabitaciones || ""} onChange={e => setNumeroHabitaciones(e.target.value)}>
                                    <option></option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6+</option>
                                </Select>
                            </FlexBox>
                            <FlexBox>
                                <Label>¿Esta es la primera consulta?</Label>
                                <Select value={primeraConsulta || ""} onChange={e => {const valor = e.target.value;setPrimeraConsulta(valor); if (valor !== "Si") {setPrimeraConsultaFecha("");}}}>
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                                </FlexBox>
                                {primeraConsulta === "Si" ?

                                    <FlexBox>

                                        <Label>
                                            Fecha de la primera consulta
                                        </Label>

                                        <Input
                                            type="date"
                                            name="primeraConsultaFecha"
                                            value={primeraConsultaFecha || ""}
                                            onChange={e =>
                                                setPrimeraConsultaFecha(
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </FlexBox>

                                : ""}
                            
                            <div>
                                <FlexBox>
                                <Label>¿Hubo tratamientos previos con otras profesiones?</Label>
                                <Select
                                    value={tratamientosPrevios || ""}
                                    onChange={e => {

                                        const valor =
                                            e.target.value;

                                        setTratamientosPrevios(
                                            valor
                                        );

                                        /*
                                        Si deja de indicar que hubo
                                        tratamientos previos, limpiamos
                                        toda la información dependiente.
                                        */

                                        if (valor !== "Si") {
                                            limpiarTratamientosPrevios();
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                                </FlexBox>
                                {tratamientosPrevios === "Si" ? 
                                <div>
                                    <div>
                                        <Label>Profesional 1</Label>
                                        <Select value={tratamientosPrevios1 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios1(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(1);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios1 !== "" && tratamientosPrevios1 !== undefined ?
                                            <FlexColumn>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios1Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios1Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>


                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios1DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios1DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>


                                                    <Select
                                                        value={tratamientosPrevios1DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios1DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios1Institucion || ""}
                                                    onChange={e => setTratamientosPrevios1Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios1Profesional || ""}
                                                    onChange={e => setTratamientosPrevios1Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </FlexColumn>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 2</Label>
                                        <Select value={tratamientosPrevios2 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios2(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(2);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios2 !== "" && tratamientosPrevios2 !== undefined ?
                                            <FlexColumn>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios2Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios2Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios2DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios2DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios2DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios2DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11 }).map((opt, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={i + 1}
                                                            >
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios2Institucion || ""}
                                                    onChange={e => setTratamientosPrevios2Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios2Profesional || ""}
                                                    onChange={e => setTratamientosPrevios2Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </FlexColumn>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 3</Label>
                                        <Select value={tratamientosPrevios3 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios3(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(3);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios3 !== "" && tratamientosPrevios3 !== undefined ?
                                            <div>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios3Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios3Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios3DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios3DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios3DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios3DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11}).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios3Institucion || ""}
                                                    onChange={e => setTratamientosPrevios3Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios3Profesional || ""}
                                                    onChange={e => setTratamientosPrevios3Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 4</Label>
                                        <Select value={tratamientosPrevios4 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios4(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(4);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios4 !== "" && tratamientosPrevios4 !== undefined ?
                                            <div>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios4Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios4Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios4DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios4DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios4DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios4DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11}).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                    <Label htmlFor="text">
                                                        Institución donde se realizó
                                                    </Label>

                                                    <Input
                                                        type="text"
                                                        name="institucion"
                                                        placeholder="En qué institución"
                                                        value={tratamientosPrevios4Institucion || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios4Institucion(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios4Profesional || ""}
                                                    onChange={e => setTratamientosPrevios4Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 5</Label>
                                        <Select value={tratamientosPrevios5 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios5(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(5);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios5 !== "" && tratamientosPrevios5 !== undefined ?
                                            <div>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios5Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios5Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios5DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios5DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios5DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios5DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11}).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios5Institucion || ""}
                                                    onChange={e => setTratamientosPrevios5Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios5Profesional || ""}
                                                    onChange={e => setTratamientosPrevios5Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 6</Label>
                                        <Select value={tratamientosPrevios6 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios6(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(6);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios6 !== "" && tratamientosPrevios6 !== undefined ?
                                            <div>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios6Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios6Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios6DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios6DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios6DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios6DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11}).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios6Institucion || ""}
                                                    onChange={e => setTratamientosPrevios6Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios6Profesional || ""}
                                                    onChange={e => setTratamientosPrevios6Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    <div>
                                        <Label>Profesional 7</Label>
                                        <Select value={tratamientosPrevios7 || ""} 
                                        onChange={e => {

                                            const valor = e.target.value;

                                            setTratamientosPrevios7(valor);

                                            if (!valor) {
                                                limpiarTratamientoProfesional(7);
                                            }
                                        }}>
                                            <option></option>
                                            <option>Psicopedagogía</option>
                                            <option>Psicología</option>
                                            <option>Terapia Ocupacional</option>
                                            <option>Fonoaudiología</option>
                                            <option>Psicomotricista</option>
                                            <option>Musicoterapia</option>
                                            <option>Otro</option>
                                        </Select>
                                        {tratamientosPrevios7 !== "" && tratamientosPrevios7 !== undefined ?
                                            <div>
                                                <FlexBox align="center">
                                                    <Label>Edad</Label>

                                                    <Select
                                                        value={tratamientosPrevios7Edad || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios7Edad(e.target.value)
                                                        }
                                                    >
                                                        <option value="">¿A qué edad?</option>

                                                        {Array.from({ length: 18 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>

                                                <FlexBox align="center">
                                                    <Label>Duración</Label>

                                                    <Select
                                                        value={tratamientosPrevios7DuracionAnios || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios7DuracionAnios(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Años</option>

                                                        {Array.from({ length: 10 }).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>

                                                    <Select
                                                        value={tratamientosPrevios7DuracionMeses || ""}
                                                        onChange={e =>
                                                            setTratamientosPrevios7DuracionMeses(e.target.value)
                                                        }
                                                    >
                                                        <option value="">Meses</option>

                                                        {Array.from({ length: 11}).map((opt, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Institución donde se realizó</Label>
                                                <Input
                                                    type="text"
                                                    name="institucion"
                                                    placeholder="En que institución"
                                                    value={tratamientosPrevios7Institucion || ""}
                                                    onChange={e => setTratamientosPrevios7Institucion(e.target.value)}
                                                />
                                                </FlexBox>
                                                <FlexBox align="center">
                                                <Label htmlFor="text">Datos del profesional</Label>
                                                <Input
                                                    type="text"
                                                    name="profesional"
                                                    placeholder="Datos del profesional"
                                                    value={tratamientosPrevios7Profesional || ""}
                                                    onChange={e => setTratamientosPrevios7Profesional(e.target.value)}
                                                />
                                                </FlexBox>
                                            </div>
                                            : ""
                                        }
                                    </div>
                                </div>
                                
                                : ""
                                }
                            </div>
                            <FlexBox> 
                                <Label>El español es su lengua materna</Label>
                                <Select
                                    value={espaniolMaterno || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setEspaniolMaterno(valor);

                                        if (valor !== "No") {
                                            setIdiomaMaterno("");
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                                </FlexBox>
                                {espaniolMaterno === "No" ?
                                    <FlexBox>
                                        <Label htmlFor="text">¿Cuál es su idioma Materno?</Label>
                                        <Input
                                            type="text"
                                            name="idiomaMaterno"
                                            placeholder="Idioma"
                                            value={idiomaMaterno || ""}
                                            onChange={e => setIdiomaMaterno(e.target.value)}
                                        />
                                    </FlexBox>
                                    : ""
                                }
                            
                            <FlexBox>
                                <Label>¿Es Bilingüe?</Label>
                                <Select
                                    value={infoBilingue || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setInfoBilingue(valor);

                                        if (valor !== "Si") {
                                            setIdiomaBilingue("");
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                                </FlexBox>
                                {infoBilingue === "Si" ?
                                    <FlexBox>
                                        <Label htmlFor="text">¿Cuál es su idioma bilingüe?</Label>
                                        <Input
                                            type="text"
                                            name="idiomaBilingue"
                                            placeholder="Idioma"
                                            value={idiomaBilingue || ""}
                                            onChange={e => setIdiomaBilingue(e.target.value)}
                                        />
                                    </FlexBox>
                                    : ""
                                }
                            
                        </Margen>
                        : ""
                        }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Embarazo.respondidas}/${avanceAnamnesis.secciones.Embarazo.total}`}
                            onClick={(e) => manejarActivo(e, "Embarazo")}
                        >
                            Embarazo
                        </Boton>
                    </div>
                    <div> 
                    {activo === "Embarazo" ?
                        <Margen >
                            <FlexBox>
                                <Label>Estado de la pareja</Label>
                                <Select value={estadoPareja || ""} onChange={e => setEstadoPareja(e.target.value)} margin="5px 0px 5px 20vw" padding="5px">
                                    <option></option>
                                    <option>Pareja</option>
                                    <option>Casados</option>
                                    <option>Divorciados</option>
                                    <option>Separados</option>
                                    <option>Sin vínculo</option>
                                </Select>
                                </FlexBox>
                            <FlexBox>
                                <Label>Embarazo buscado</Label>
                                <Select value={embarazoBuscado || ""} onChange={e => setEmbarazoBuscado(e.target.value)}  margin="5px 0px 5px 20vw" padding="5px">
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                                <InputSmall  margin="5px 0px 5px 2vw" 
                                            type="text"
                                            name="embarazoBuscadoComentarios"
                                            placeholder="Comentario"
                                            value={embarazoBuscadoComentario || ""}
                                            onChange={e => setEmbarazoBuscadoComentario(e.target.value)}
                                        />
                            </FlexBox>
                            <FlexBox>

                                <Label>
                                    Sexo esperado por la madre
                                </Label>

                                <Select
                                    value={sexoEsperadoMadre || ""}
                                    onChange={e =>
                                        setSexoEsperadoMadre(
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="">
                                        Seleccionar
                                    </option>

                                    <option>Femenino</option>
                                    <option>Masculino</option>
                                    <option>Indistinto</option>

                                </Select>

                            </FlexBox>


                            <FlexBox>

                                <Label>
                                    Sexo esperado por el padre
                                </Label>

                                <Select
                                    value={sexoEsperadoPadre || ""}
                                    onChange={e =>
                                        setSexoEsperadoPadre(
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="">
                                        Seleccionar
                                    </option>

                                    <option>Femenino</option>
                                    <option>Masculino</option>
                                    <option>Indistinto</option>

                                </Select>

                            </FlexBox>
                            <FlexBox>
                                <Label htmlFor="text">Síntomas</Label>
                                <Input  margin="5px 0px 5px 25.5vw" padding="5px"
                                    type="text"
                                    name="sintomas"
                                    placeholder="Síntomas"
                                    value={infoSintomas || ""}
                                    onChange={e => setInfoSintomas(e.target.value)}
                                />
                            </FlexBox>
                            <FlexBox>
                                <Label htmlFor="text">Enfermedades o accidentes durante el embarazo</Label>
                                <Input  margin="5px 0px 5px 3.5vw" padding="5px"
                                    type="text"
                                    name="enfermedadesAccidentesEmbarazo"
                                    value={enfermedadesAccidentesEmbarazo || ""}
                                    onChange={e => setEnfermedadesAccidentesEmbarazo(e.target.value)}
                                />
                            </FlexBox>
                            <div>
                            <FlexBox>
                                <Label>Presencia de abortos antes o despues</Label>
                                <Select
                                    value={abortosAntesDespues || ""}
                                    onChange={e => {

                                        const valor =
                                            e.target.value;

                                        setAbortosAntesDespues(
                                            valor
                                        );

                                        /*
                                        Si no hubo abortos, eliminamos
                                        los datos dependientes para evitar
                                        conservar información oculta.
                                        */

                                        if (valor !== "Si") {
                                            setCantidadAbortos("");
                                            setMotivoAbortos("");
                                            setProvocadoEspontaneo("");
                                        }
                                    }}
                                    margin="5px 0px 5px 9.8vw"
                                    padding="5px"
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                            </FlexBox>
                                {abortosAntesDespues === "Si" ?
                                    <FlexColumn>
                                        <FlexBox aling="center">
                                            <Label>Cantidad</Label>
                                            <Select
                                                value={cantidadAbortos || ""}
                                                onChange={e => setCantidadAbortos(e.target.value)}
                                                margin="5px 2vw 5px 2vw"
                                                padding="5px"
                                            >
                                                <option value="">Cantidad</option>

                                                {Array.from({ length: 15 }).map((opt, i) => (
                                                    <option
                                                        key={i + 1}
                                                        value={i + 1}
                                                    >
                                                        {i + 1}
                                                    </option>
                                                ))}
                                            </Select>
                                        </FlexBox>
                                        <FlexBox aling="center">
                                            <Label htmlFor="text">Motivo</Label>
                                            <Input margin="5px 0px 5px 2vw" 
                                                type="text"
                                                name="motivoAbortos"
                                                value={motivoAbortos || ""}
                                                onChange={e => setMotivoAbortos(e.target.value)}
                                            />
                                        </FlexBox>
                                        <FlexBox aling="center">
                                            <Label htmlFor="text">Provocado o espontaneo</Label>
                                            <Input margin="5px 0px 5px 3vw"
                                                type="text"
                                                name="provocadoEspontaneo"
                                                value={provocadoEspontaneo || ""}
                                                onChange={e => setProvocadoEspontaneo(e.target.value)}
                                            />
                                        </FlexBox>
                                    </FlexColumn>
                                : ""
                                }
                            </div>
                            <FlexBox>
                                <Label htmlFor="text">Asfixia Perinatal</Label>
                                <Input margin="5px 0px 5px 22vw" 
                                    type="text"
                                    name="asfixiaPerinatal"
                                    value={asfixiaPerinatal || ""}
                                    onChange={e => setAsfixiaPerinatal(e.target.value)}
                                />
                            </FlexBox>
                        </Margen >
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Parto.respondidas}/${avanceAnamnesis.secciones.Parto.total}`}
                            onClick={(e) => manejarActivo(e, "Parto")}
                        >
                            Parto
                        </Boton>
                    </div>
                    <div> {activo === "Parto" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Cómo fue el parto?</Label>
                            <Select value={infoParto || ""} onChange={e => setInfoParto(e.target.value)}  margin="5px 0px 5px 20vw" >
                                <option></option>
                                <option>Rompio Bolsa</option>
                                <option>Inducción</option>
                                <option>Cesarea</option>
                                <option>Cesarea programada</option>
                            </Select>
                            <InputSmall  margin="5px 0px 5px 2vw" 
                                type="text"
                                name="partoComentario"
                                placeholder="Comentario"
                                value={partoComentario || ""}
                                onChange={e => setPartoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Semana</Label>
                            <Select
                                value={partoSemana || ""}
                                onChange={e => setPartoSemana(e.target.value)}
                                margin="5px 0px 5px 26.5vw"
                            >
                                <option value="">Semana</option>

                                {Array.from({ length: 41 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                        </FlexBox>
                        <FlexBox>
                            <Label htmlFor="text">Duración</Label>
                            <Input  margin="5px 0px 5px 26vw" 
                                type="text"
                                name="partoDuracion"
                                placeholder="Parto prolongado o rápido"
                                value={partoDuracion || ""}
                                onChange={e => setPartoDuracion(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>APGAR</Label>
                            <Select
                                    value={infoApgar || ""}
                                    onChange={e => setInfoApgar(e.target.value)}
                                    margin="5px 0px 5px 27vw"
                                >
                                    <option value="">APGAR</option>

                                    {Array.from({ length: 10 }).map((opt, i) => (
                                        <option
                                            key={i + 1}
                                            value={i + 1}
                                        >
                                            {i + 1}
                                        </option>
                                    ))}
                                </Select>
                        </FlexBox>
                        <FlexBox>
                            <Label>Peso Kg</Label>
                            <Input  margin="5px 0px 5px 27vw" 
                                type="number"
                                name="peso"
                                placeholder="Ej 3.25"
                                step="0.01"
                                max="6"
                                value={infoPeso || ""}
                                onChange={e => setInfoPeso(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Complicaciones en el parto</Label>
                            <Select value={partoComplicacion || ""} onChange={e => setPartoComplicacion(e.target.value)}  margin="5px 0px 5px 16vw" >
                                <option></option>
                                <option>Forceps</option>
                                <option>Cesarea</option>
                                <option>Medicación</option>
                                <option>Otro</option>
                            </Select>
                            <InputSmall  margin="5px 0px 5px 2vw" 
                                type="text"
                                name="partoComplicacionComentario"
                                placeholder="Comentario"
                                value={partoComplicacionComentario || ""}
                                onChange={e => setPartoComplicacionComentario(e.target.value)}
                            />
                        </FlexBox>
                        <div>
                            <FlexBox>
                            <Label>Reacción al nacer</Label>
                            <Select
                                value={bebeReaccion || ""}
                                onChange={e => {

                                    const valor =
                                        e.target.value;

                                    setBebeReaccion(
                                        valor
                                    );

                                    if (
                                        valor !== "Complicaciones"
                                    ) {
                                        setBebeComplicacion("");
                                        setBebeComplicacionComentario("");
                                    }
                                }}
                                margin="5px 0px 5px 22vw"
                            >
                                <option></option>
                                <option>Llanto instantaneo</option>
                                <option>Complicaciones</option>
                            </Select>
                            </FlexBox>
                            {bebeReaccion === "Complicaciones" ? 
                                <FlexBox>
                                    <Label>Complicación al nacer</Label>
                                    <Select value={bebeComplicacion || ""} onChange={e => setBebeComplicacion(e.target.value)}>
                                        <option></option>
                                        <option>Asfixia</option>
                                        <option>Cianosis</option>
                                        <option>Morado</option>
                                        <option>ictericia</option>
                                        <option>Reanimación</option>
                                        <option>Otro</option>
                                    </Select>
                                    <InputSmall
                                        type="text"
                                        name="bebeComplicacionComentario"
                                        placeholder="Comentario"
                                        value={bebeComplicacionComentario || ""}
                                        onChange={e => setBebeComplicacionComentario(e.target.value)}
                                    />
                                </FlexBox>
                            : ""
                            }
                        </div>
                        <div>
                        <FlexBox>
                            <Label>Incubadora</Label>
                            <Select
                                value={infoIncubadora || ""}
                                onChange={e => {

                                    const valor =
                                        e.target.value;

                                    setInfoIncubadora(
                                        valor
                                    );

                                    /*
                                    Si no requirió incubadora,
                                    limpiamos horas y comentario.
                                    */

                                    if (valor !== "Si") {
                                        setIncubadoraHoras("");
                                        setIncubadoraComentario("");
                                    }
                                }}
                            >
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                        </FlexBox>
                            {infoIncubadora === "Si" ? 
                                <FlexBox>
                                    <Label>¿Cuántas horas al día?</Label>
                                    <Select
                                        value={incubadoraHoras || ""}
                                        onChange={e => setIncubadoraHoras(e.target.value)}
                                    >
                                        <option value="">Horas</option>

                                        {Array.from({ length: 24 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>
                                    <InputSmall
                                        type="text"
                                        name="incubadoraComentario"
                                        placeholder="Comentario"
                                        value={incubadoraComentario || ""}
                                        onChange={e => setIncubadoraComentario(e.target.value)}
                                    />
                                </FlexBox>
                            : ""
                            }
                        </div>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Lactancia.respondidas}/${avanceAnamnesis.secciones.Lactancia.total}`}
                            onClick={(e) => manejarActivo(e, "Lactancia")}
                        >
                            Lactancia
                        </Boton>
                    </div>
                    <div> {activo === "Lactancia" ?
                    <Margen>
                        <div>
                            <FlexBox>
                            <Label>Pecho</Label>
                            <Select
                                value={infoPecho || ""}
                                onChange={e => {

                                    const valor =
                                        e.target.value;

                                    setInfoPecho(valor);

                                    /*
                                    Si deja de recibir pecho,
                                    eliminamos los datos que dependen
                                    directamente de esa respuesta.
                                    */

                                    if (valor !== "Si") {
                                        setPechoMes("");
                                        setPechoComentario("");
                                        setPechoPrendioComentario("");
                                    }
                                }}
                            >
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            </FlexBox>
                            {infoPecho === "Si" ? 
                                <>
                                    <FlexBox>
                                        <Label>¿Hasta qué mes?</Label>

                                        <Select
                                            value={pechoMes || ""}
                                            onChange={e =>
                                                setPechoMes(e.target.value)
                                            }
                                        >
                                            <option value="">Mes</option>

                                            {Array.from({ length: 24 }).map((opt, i) => (
                                                <option
                                                    key={i + 1}
                                                    value={i + 1}
                                                >
                                                    {i + 1}
                                                </option>
                                            ))}
                                        </Select>

                                        <InputSmall
                                            type="text"
                                            name="pechoComentario"
                                            placeholder="Comentario"
                                            value={pechoComentario || ""}
                                            onChange={e =>
                                                setPechoComentario(e.target.value)
                                            }
                                        />
                                    </FlexBox>

                                    <FlexBox>
                                        <Label>
                                            ¿Cómo se prendió del pecho?
                                        </Label>

                                        <Input
                                            type="text"
                                            name="pechoPrendioComentario"
                                            placeholder="Comentario"
                                            value={pechoPrendioComentario || ""}
                                            onChange={e =>
                                                setPechoPrendioComentario(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </FlexBox>
                                </>
                            : ""
                            }
                        </div>
                        <FlexBox>
                            <Label>¿Era bebe llorón?</Label>
                            <Input
                                type="text"
                                name="bebeLloronComentario"
                                placeholder="Comentario"
                                value={bebeLloronComentario || ""}
                                onChange={e => setBebeLloronComentario(e.target.value)}
                            />
                        </FlexBox>
                        <div>
                        <FlexBox>
                            <Label>¿Usó chupete?</Label>
                            <Select
                                value={infoChupete || ""}
                                onChange={e => {

                                    const valor =
                                        e.target.value;

                                    setInfoChupete(valor);

                                    if (valor !== "Si") {
                                        setChupeteMes("");
                                        setChupeteComentario("");
                                    }
                                }}
                            >
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                        </FlexBox>
                            {infoChupete === "Si" ? 
                                <FlexBox>
                                    <Label>¿Hasta qué mes?</Label>
                                    <Select
                                        value={chupeteMes || ""}
                                        onChange={e => setChupeteMes(e.target.value)}
                                    >
                                        <option value="">Mes</option>

                                        {Array.from({ length: 24 }).map((opt, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>
                                    <InputSmall
                                        type="text"
                                        name="chupeteComentario"
                                        placeholder="Comentario"
                                        value={chupeteComentario || ""}
                                        onChange={e => setChupeteComentario(e.target.value)}
                                    />
                                </FlexBox>
                            : ""
                            }
                        </div>
                        <div>
                        <FlexBox>
                            <Label>¿Succión del pulgar?</Label>
                            <Select
                                value={succionPulgar || ""}
                                onChange={e => {

                                    const valor =
                                        e.target.value;

                                    setSuccionPulgar(valor);

                                    if (valor !== "Si") {
                                        setSuccionPulgarMes("");
                                        setSuccionPulgarComentario("");
                                    }
                                }}
                            >
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                        </FlexBox>
                            {succionPulgar === "Si" ? 
                                <FlexBox>
                                    <Label>¿Hasta qué mes?</Label>
                                    <Select
                                        value={succionPulgarMes || ""}
                                        onChange={e => setSuccionPulgarMes(e.target.value)}
                                    >
                                        <option value="">Mes</option>

                                        {Array.from({ length: 24 }).map((opt, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>
                                    <InputSmall
                                        type="text"
                                        name="succionPulgarComentario"
                                        placeholder="Comentario"
                                        value={succionPulgarComentario || ""}
                                        onChange={e => setSuccionPulgarComentario(e.target.value)}
                                    />
                                </FlexBox>
                            : ""
                            }
                        </div>
                        <div>
                            <FlexBox>
                                <Label>¿Uso fular?</Label>
                                <Select
                                    value={usoFular || ""}
                                    onChange={e => {

                                        const valor =
                                            e.target.value;

                                        setUsoFular(valor);

                                        if (valor !== "Si") {
                                            setUsoFularHoras("");
                                            setUsoFularComentario("");
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                            </FlexBox>
                            {usoFular === "Si" ? 
                                <FlexBox>
                                    <Label>¿Cuántas horas por día?</Label>
                                    <Select
                                        value={usoFularHoras || ""}
                                        onChange={e => setUsoFularHoras(e.target.value)}
                                    >
                                        <option value="">Horas</option>

                                        {Array.from({ length: 24 }).map((opt, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>
                                    <InputSmall
                                        type="text"
                                        name="usoFularComentario"
                                        placeholder="Comentario"
                                        value={usoFularComentario || ""}
                                        onChange={e => setUsoFularComentario(e.target.value)}
                                    />
                                </FlexBox>
                            : ""
                            }
                        </div>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Alimentacion.respondidas}/${avanceAnamnesis.secciones.Alimentacion.total}`}
                            onClick={(e) => manejarActivo(e, "Alimentacion")}
                        >
                            Alimentación
                        </Boton>    
                    </div>
                    <div> {activo === "Alimentacion" ?
                    <Margen>
                        <div>
                            <FlexBox>
                                <Label>Tomó mamadera</Label>

                                <Select
                                    value={infoMamadera || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setInfoMamadera(valor);

                                        /*
                                        Si deja de usar la opción "Sí",
                                        limpiamos los datos dependientes
                                        para no guardar información vieja.
                                        */
                                        if (valor !== "Si") {
                                            setMamaderaEdad("");
                                            setMamaderaComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>


                            {infoMamadera === "Si" ?
                                <FlexBox>
                                    <Label>Hasta qué edad</Label>

                                    <Select
                                        value={mamaderaEdad || ""}
                                        onChange={e =>
                                            setMamaderaEdad(e.target.value)
                                        }
                                    >
                                        <option value="">Edad</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="mamaderaComentario"
                                        placeholder="Comentario"
                                        value={mamaderaComentario || ""}
                                        onChange={e =>
                                            setMamaderaComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}
                        </div>
                        <FlexBox>
                            <Label>Con la madre o solo</Label>
                            <Input
                                type="text"
                                name="mamaderaSoloComentario"
                                placeholder="Comentario"
                                value={mamaderaSoloComentario || ""}
                                onChange={e => setMamaderaSoloComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cómo fue la adaptación a lo sólido?</Label>
                            <Input
                                type="text"
                                name="adaptacionSolidoComentario"
                                placeholder="Comentario"
                                value={adaptacionSolidoComentario || ""}
                                onChange={e => setAdaptacionSolidoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Rechazo dulce o salado</Label>
                            <Input
                                type="text"
                                name="dulceSaladoComentario"
                                placeholder="Comentario"
                                value={dulceSaladoComentario || ""}
                                onChange={e => setDulceSaladoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cómo aceptó la nueva alimentación?</Label>
                            <Input
                                type="text"
                                name="aceptarAlimentacionComentario"
                                placeholder="Comentario"
                                value={aceptarAlimentacionComentario || ""}
                                onChange={e => setAceptarAlimentacionComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Rechazó algún alimento?</Label>
                            <Input
                                type="text"
                                name="rechazoAlimentoComentario"
                                placeholder="Comentario"
                                value={rechazoAlimentoComentario || ""}
                                onChange={e => setRechazoAlimentoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cómo y cuándo empezó a comer solo?</Label>
                            <Input
                                type="text"
                                name="comerSoloComentario"
                                placeholder="Comentario"
                                value={comerSoloComentario || ""}
                                onChange={e => setComerSoloComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Tiene horarios de comida?</Label>
                            <Input
                                type="text"
                                name="horariosComidaComentario"
                                placeholder="Comentario"
                                value={horariosComidaComentario || ""}
                                onChange={e => setHorariosComidaComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Denticion.respondidas}/${avanceAnamnesis.secciones.Denticion.total}`}
                            onClick={(e) => manejarActivo(e, "Denticion")}
                        >
                            Dentición
                        </Boton>
                    </div>
                    <div> {activo === "Denticion" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Cuándo le salió el primer diente?</Label>
                            <Input
                                type="text"
                                name="primerDienteComentario"
                                placeholder="Comentario"
                                value={primerDienteComentario || ""}
                                onChange={e => setPrimerDienteComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Tuvo molestias?</Label>
                            <Input
                                type="text"
                                name="dienteMolestiasComentario"
                                placeholder="Comentario"
                                value={dienteMolestiasComentario || ""}
                                onChange={e => setDienteMolestiasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Segunda dentición?</Label>
                            <Input
                                type="text"
                                name="segundaDenticionComentario"
                                placeholder="Comentario"
                                value={segundaDenticionComentario || ""}
                                onChange={e => setSegundaDenticionComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Reacción ante la caída de los dientes?</Label>
                            <Input
                                type="text"
                                name="caidaDientesComentario"
                                placeholder="Comentario"
                                value={caidaDientesComentario || ""}
                                onChange={e => setCaidaDientesComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Motricidad.respondidas}/${avanceAnamnesis.secciones.Motricidad.total}`}
                            onClick={(e) => manejarActivo(e, "Motricidad")}
                        >
                            Motricidad
                        </Boton>
                    </div>
                    <div> {activo === "Motricidad" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿En qué mes sostuvo la cabeza?</Label>
                            <Select
                                value={cabezaMes || ""}
                                onChange={e => setCabezaMes(e.target.value)}
                            >
                                <option value="">Mes</option>

                                {Array.from({ length: 20 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="cabezaComentario"
                                placeholder="Comentario"
                                value={cabezaComentario || ""}
                                onChange={e => setCabezaComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿En qué mes se sentó sin apoyo?</Label>
                            <Select
                                value={sentoMes || ""}
                                onChange={e => setSentoMes(e.target.value)}
                            >
                                <option value="">Mes</option>

                                {Array.from({ length: 20 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="sentoComentario"
                                placeholder="Comentario"
                                value={sentoComentario || ""}
                                onChange={e => setSentoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿En qué mes gateó?</Label>
                            <Select
                                value={gateoMes || ""}
                                onChange={e => setGateoMes(e.target.value)}
                            >
                                <option value="">Mes</option>

                                {Array.from({ length: 20 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="gateoComentario"
                                placeholder="Comentario"
                                value={gateoComentario || ""}
                                onChange={e => setGateoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿En qué mes caminó?</Label>
                            <Select
                                value={caminoMes || ""}
                                onChange={e => setCaminoMes(e.target.value)}
                            >
                                <option value="">Mes</option>

                                {Array.from({ length: 20 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="caminoComentario"
                                placeholder="Comentario"
                                value={caminoComentario || ""}
                                onChange={e => setCaminoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexColumn>
                            <FlexBox>
                            <Label>Lateralizado Mano</Label>
                            <Select value={infoMano || ""} onChange={e => setInfoMano(e.target.value)}>
                                <option></option>
                                <option>Izquierda</option>
                                <option>Derecha</option>
                            </Select>
                            </FlexBox>
                            <FlexBox>
                            <Label>Lateralizado Pie</Label>
                            <Select value={infoPie || ""} onChange={e => setInfoPie(e.target.value)}>
                                <option></option>
                                <option>Izquierda</option>
                                <option>Derecha</option>
                            </Select>
                            </FlexBox>
                        </FlexColumn>
                        <FlexBox>
                            <Label>¿Es hábil en sus movimientos?</Label>
                            <Select value={infoHabil || ""} onChange={e => setInfoHabil(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="habilComentario"
                                placeholder="Comentario"
                                value={habilComentario || ""}
                                onChange={e => setHabilComentario(e.target.value)}
                            /> 
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.ControlEsfinteres.respondidas}/${avanceAnamnesis.secciones.ControlEsfinteres.total}`}
                            onClick={(e) => manejarActivo(e, "ControlEsfinteres")}
                        >
                            Control de Esfínteres
                        </Boton>
                    </div>
                    <div> {activo === "ControlEsfinteres" ?
                    <Margen>
                        <FlexBox>

                            <Label>
                                Edad de inicio del aprendizaje
                            </Label>

                            <Select
                                value={aprendizajeEsfinteresAnio || ""}
                                onChange={e =>
                                    setAprendizajeEsfinteresAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 8 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={aprendizajeEsfinteresMes || ""}
                                onChange={e =>
                                    setAprendizajeEsfinteresMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="aprendizajeEsfinteresComentario"
                                placeholder="Comentario"
                                value={aprendizajeEsfinteresComentario || ""}
                                onChange={e =>
                                    setAprendizajeEsfinteresComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>


                        <SubtituloFormulario>
                            Edad en que se retiraron los pañales
                        </SubtituloFormulario>


                        <FlexBox>

                            <Label>
                                Retiro del pañal de día
                            </Label>

                            <Select
                                value={retiraronPanialesDiaAnio || ""}
                                onChange={e =>
                                    setRetiraronPanialesDiaAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 8 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={retiraronPanialesDiaMes || ""}
                                onChange={e =>
                                    setRetiraronPanialesDiaMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="retiraronPanialesDiaComentario"
                                placeholder="Comentario"
                                value={retiraronPanialesDiaComentario || ""}
                                onChange={e =>
                                    setRetiraronPanialesDiaComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>


                        <FlexBox>

                            <Label>
                                Retiro del pañal de noche
                            </Label>

                            <Select
                                value={retiraronPanialesNocheAnio || ""}
                                onChange={e =>
                                    setRetiraronPanialesNocheAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 8 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={retiraronPanialesNocheMes || ""}
                                onChange={e =>
                                    setRetiraronPanialesNocheMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="retiraronPanialesNocheComentario"
                                placeholder="Comentario"
                                value={retiraronPanialesNocheComentario || ""}
                                onChange={e =>
                                    setRetiraronPanialesNocheComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>


                        <SubtituloFormulario>
                            Control de esfínteres
                        </SubtituloFormulario>


                        <FlexBox>

                            <Label>
                                Control de esfínteres de día
                            </Label>

                            <Select
                                value={controlEsfinteresDiaAnio || ""}
                                onChange={e =>
                                    setControlEsfinteresDiaAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 8 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={controlEsfinteresDiaMes || ""}
                                onChange={e =>
                                    setControlEsfinteresDiaMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="controlEsfinteresDiaComentario"
                                placeholder="Comentario"
                                value={controlEsfinteresDiaComentario || ""}
                                onChange={e =>
                                    setControlEsfinteresDiaComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>


                        <FlexBox>

                            <Label>
                                Control de esfínteres de noche
                            </Label>

                            <Select
                                value={controlEsfinteresNocheAnio || ""}
                                onChange={e =>
                                    setControlEsfinteresNocheAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 8 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={controlEsfinteresNocheMes || ""}
                                onChange={e =>
                                    setControlEsfinteresNocheMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="controlEsfinteresNocheComentario"
                                placeholder="Comentario"
                                value={controlEsfinteresNocheComentario || ""}
                                onChange={e =>
                                    setControlEsfinteresNocheComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>
                        <FlexBox>
                            <Label>Si el niño no controlaba, ¿qué hacían los padres?</Label>
                            <Input
                                type="text"
                                name="controlEsfinteresReaccionPadresComentario"
                                placeholder="Comentario"
                                value={controlEsfinteresReaccionPadresComentario || ""}
                                onChange={e => setControlEsfinteresReaccionPadresComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexColumn>
                            <FlexBox>
                                <Label>¿Actualmente se atiende solo en el baño?</Label>
                                <Select
                                    value={esfinteresSolo || ""}
                                    onChange={e => {

                                        const valor = e.target.value;

                                        setEsfinteresSolo(valor);

                                        /*
                                        Si deja de indicar que se atiende
                                        solo en el baño, eliminamos la edad
                                        y el comentario dependientes.
                                        */

                                        if (valor !== "Si") {
                                            setEsfinteresSoloAnio("");
                                            setEsfinteresSoloComentario("");
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                            </FlexBox>
                            {esfinteresSolo === "Si" ? 
                            <FlexBox>
                                <Label>¿Desde qué edad?</Label>
                                <Select
                                    value={esfinteresSoloAnio || ""}
                                    onChange={e => setEsfinteresSoloAnio(e.target.value)}
                                >
                                    <option value="">Edad</option>
                                    {Array.from({ length: 12 }).map((opt, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </option>
                                    ))}
                                </Select>
                            <InputSmall
                                type="text"
                                name="esfinteresSoloComentario"
                                placeholder="Comentario"
                                value={esfinteresSoloComentario || ""}
                                onChange={e => setEsfinteresSoloComentario(e.target.value)}
                            />
                            </FlexBox>
                            : ""
                            }
                        </FlexColumn>
                        <FlexBox>
                            <Label>¿Actualmente se baña solo?</Label>
                            <InputSmall
                                type="text"
                                name="baniaSoloComentario"
                                placeholder="Comentario"
                                value={baniaSoloComentario || ""}
                                onChange={e => setBaniaSoloComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Actualmente se viste solo?</Label>
                            <Input
                                type="text"
                                name="visteSoloComentario"
                                placeholder="Comentario"
                                value={visteSoloComentario || ""}
                                onChange={e => setVisteSoloComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Enuresis</Label>
                            <Select value={infoEnuresis || ""} onChange={e => setInfoEnuresis(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="enuresisComentario"
                                placeholder="Comentario"
                                value={enuresisComentario || ""}
                                onChange={e => setEnuresisComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Encopresis</Label>
                            <Select value={infoEncopresis || ""} onChange={e => setInfoEncopresis(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="encopresisComentario"
                                placeholder="Comentario"
                                value={encopresisComentario || ""}
                                onChange={e => setEncopresisComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Lenguaje.respondidas}/${avanceAnamnesis.secciones.Lenguaje.total}`}
                            onClick={(e) => manejarActivo(e, "Lenguaje")}
                        >
                            Lenguaje
                        </Boton>
                    </div>
                    <div> {activo === "Lenguaje" ?
                    <Margen>
                        <FlexBox>
                            <Label>Primeras palabras, en que mes?</Label>
                            <Select
                                value={primerasPalabrasMes || ""}
                                onChange={e => setPrimerasPalabrasMes(e.target.value)}
                            >
                                <option value="">Mes</option>

                                {Array.from({ length: 20 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="primerasPalabrasComentario"
                                placeholder="Comentario"
                                value={primerasPalabrasComentario || ""}
                                onChange={e => setPrimerasPalabrasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Presentó alguna dificultad en el lenguaje?</Label>
                            <Input
                                type="text"
                                name="lenguajeDificultadComentario"
                                placeholder="Comentario"
                                value={lenguajeDificultadComentario || ""}
                                onChange={e => setLenguajeDificultadComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cómo es su lenguaje?</Label>
                            <Input
                                type="text"
                                name="lenguajeComentario"
                                placeholder="Comentario"
                                value={lenguajeComentario || ""}
                                onChange={e => setLenguajeComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Qué edad tenía cuando las personas que no lo conocían fueron capaces de entenderle?</Label>
                            <Input
                                type="text"
                                name="lenguajeEntenderleComentario"
                                placeholder="Comentario"
                                value={lenguajeEntenderleComentario || ""}
                                onChange={e => setLenguajeEntenderleComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones['Sueño'].respondidas}/${avanceAnamnesis.secciones['Sueño'].total}`}
                            onClick={(e) => manejarActivo(e, "Sueño")}
                        >
                            Sueño
                        </Boton>
                    </div>
                    <div> {activo === "Sueño" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Donde dormía el niño cuando nació?</Label>
                            <Input
                                type="text"
                                name="dondeDormiaAlNacerComentario"
                                placeholder="Comentario"
                                value={dondeDormiaAlNacerComentario || ""}
                                onChange={e => setDondeDormiaAlNacerComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Hizo colecho?</Label>
                            <Select value={hizoColecho || ""} onChange={e => setHizoColecho(e.target.value)}>
                                <option></option>
                                <option>Dormía en la cama</option>
                                <option>Encima de la madre</option>
                                <option>Usaban algún soporte</option>
                            </Select>
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Los hermanos hicieron colecho?</Label>
                            <Select value={hermanosColecho || ""} onChange={e => setHermanosColecho(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="hermanosColechoComentario"
                                placeholder="Comentario"
                                value={hermanosColechoComentario || ""}
                                onChange={e => setHermanosColechoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cómo se organizaban cuando nacía un nuevo miembro?</Label>
                            <Input
                                type="text"
                                name="nuevoMiembroComentario"
                                placeholder="Comentario"
                                value={nuevoMiembroComentario || ""}
                                onChange={e => setNuevoMiembroComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Dónde duerme actualmente?</Label>
                            <Input
                                type="text"
                                name="dondeDuermeComentario"
                                placeholder="Comentario"
                                value={dondeDuermeComentario || ""}
                                onChange={e => setDondeDuermeComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>

                            <Label>
                                Edad desde que duerme separado de sus padres
                            </Label>

                            <Select
                                value={duermeSoloAnio || ""}
                                onChange={e =>
                                    setDuermeSoloAnio(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Años</option>

                                {Array.from({ length: 10 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <Select
                                value={duermeSoloMes || ""}
                                onChange={e =>
                                    setDuermeSoloMes(
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Meses</option>

                                {Array.from({ length: 11 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>


                            <InputSmall
                                type="text"
                                name="duermeSoloComentario"
                                placeholder="Comentario"
                                value={duermeSoloComentario || ""}
                                onChange={e =>
                                    setDuermeSoloComentario(
                                        e.target.value
                                    )
                                }
                            />

                        </FlexBox>
                        <FlexBox>
                            <Label>¿Cuántas horas duerme por día?</Label>
                            <Select
                                value={duermeHoras || ""}
                                onChange={e => setDuermeHoras(e.target.value)}
                            >
                                <option value="">Horas</option>

                                {Array.from({ length: 24 }).map((opt, i) => (
                                    <option
                                        key={i + 1}
                                        value={i + 1}
                                    >
                                        {i + 1}
                                    </option>
                                ))}
                            </Select>
                            <InputSmall
                                type="text"
                                name="duermeHorasComentario"
                                placeholder="Comentario"
                                value={duermeHorasComentario || ""}
                                onChange={e => setDuermeHorasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Actitudes cuando duerme</Label>
                            <Input
                                type="text"
                                name="duermeActitudesComentario"
                                placeholder="Comentario"
                                value={duermeActitudesComentario || ""}
                                onChange={e => setDuermeActitudesComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Duerme con luz?</Label>
                            <Select value={duermeLuz || ""} onChange={e => setDuermeLuz(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="duermeLuzComentario"
                                placeholder="Comentario"
                                value={duermeLuzComentario || ""}
                                onChange={e => setDuermeLuzComentario(e.target.value)}
                            />
                        </FlexBox>
                        <div>
                            <FlexBox>
                                <Label>¿Duerme con algún juguete?</Label>
                                <Select
                                    value={duermeJuguete || ""}
                                    onChange={e => {

                                        const valor = e.target.value;

                                        setDuermeJuguete(valor);

                                        /*
                                        Si deja de dormir con juguetes,
                                        eliminamos cantidad y comentario
                                        para no conservar datos ocultos.
                                        */

                                        if (valor !== "Si") {
                                            setDuermeJugueteCantidad("");
                                            setDuermeJugueteComentario("");
                                        }
                                    }}
                                >
                                    <option></option>
                                    <option>Si</option>
                                    <option>No</option>
                                </Select>
                            </FlexBox>
                                {duermeJuguete === "Si" ?
                                    <FlexBox>
                                        <Label>¿Con cuántos juguetes?</Label>
                                        <Select
                                            value={duermeJugueteCantidad || ""}
                                            onChange={e => setDuermeJugueteCantidad(e.target.value)}
                                        >
                                            <option value="">Cantidad</option>

                                            {Array.from({ length: 15 }).map((opt, i) => (
                                                <option
                                                    key={i + 1}
                                                    value={i + 1}
                                                >
                                                    {i + 1}
                                                </option>
                                            ))}
                                        </Select>
                                <InputSmall
                                    type="text"
                                    name="duermeJugueteComentario"
                                    placeholder="Comentario"
                                    value={duermeJugueteComentario || ""}
                                    onChange={e => setDuermeJugueteComentario(e.target.value)}
                                />
                                </FlexBox>
                                : ""}
                        </div>
                        <FlexBox>
                            <Label>¿Va a acostarse tranquilo?</Label>
                            <Input
                                type="text"
                                name="acostarseTranquiloComentario"
                                placeholder="Comentario"
                                value={acostarseTranquiloComentario || ""}
                                onChange={e => setAcostarseTranquiloComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Demora en dormirse?</Label>
                            <Input
                                type="text"
                                name="demoraDormirseComentario"
                                placeholder="Comentario"
                                value={demoraDormirseComentario || ""}
                                onChange={e => setDemoraDormirseComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.ConductaSexual.respondidas}/${avanceAnamnesis.secciones.ConductaSexual.total}`}
                            onClick={(e) => manejarActivo(e, "ConductaSexual")}
                        >
                            Conducta Sexual
                        </Boton>
                    </div>
                    <div> {activo === "ConductaSexual" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Qué pregunta hizo acerca de relaciones sexuales, embarazo, parto?</Label>
                            <Input
                                type="text"
                                name="preguntasSexualesComentario"
                                placeholder="Comentario"
                                value={preguntasSexualesComentario || ""}
                                onChange={e => setPreguntasSexualesComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox align="center">
                            <Label>¿Qué información se le dio?</Label>
                            <Input
                                type="text"
                                name="informacionSexualComentario"
                                placeholder="Comentario"
                                value={informacionSexualComentario || ""}
                                onChange={e => setInformacionSexualComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Lo vieron alguna vez tocándose los genitales?</Label>
                            <Input
                                type="text"
                                name="tocarGenitalesComentario"
                                placeholder="Comentario"
                                value={tocarGenitalesComentario || ""}
                                onChange={e => setTocarGenitalesComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Qué actitud tomaron?</Label>
                            <Input
                                type="text"
                                name="tocarGenitalesActitudComentario"
                                placeholder="Comentario"
                                value={tocarGenitalesActitudComentario || ""}
                                onChange={e => setTocarGenitalesActitudComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Enfermedades.respondidas}/${avanceAnamnesis.secciones.Enfermedades.total}`}
                            onClick={(e) => manejarActivo(e, "Enfermedades")}
                        >
                            Enfermedades
                        </Boton>
                    </div>
                    <div> {activo === "Enfermedades" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Qué enfermedades tuvo?</Label>
                            <Input
                                type="text"
                                name="enfermedadesComentario"
                                placeholder="Comentario"
                                value={enfermedadesComentario || ""}
                                onChange={e => setEnfermedadesComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Estuvo internado?</Label>
                            <Input
                                type="text"
                                name="internadoComentario"
                                placeholder="Comentario"
                                value={internadoComentario || ""}
                                onChange={e => setInternadoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Fue operado?</Label>
                            <Input
                                type="text"
                                name="operadoComentario"
                                placeholder="Comentario"
                                value={operadoComentario || ""}
                                onChange={e => setOperadoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Algún accidente?</Label>
                            <Input
                                type="text"
                                name="accidenteComentario"
                                placeholder="Comentario"
                                value={accidenteComentario || ""}
                                onChange={e => setAccidenteComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Pérdida del conocimiento?</Label>
                            <Input
                                type="text"
                                name="perdidaConocimientoComentario"
                                placeholder="Comentario"
                                value={perdidaConocimientoComentario || ""}
                                onChange={e => setPerdidaConocimientoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Convulsiones, ausencias, mareos, desmayos</Label>
                            <Input
                                type="text"
                                name="convMarDesComentario"
                                placeholder="Comentario"
                                value={convMarDesComentario || ""}
                                onChange={e => setConvMarDesComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexColumn>
                            <FlexBox>
                                <Label>¿Se realizaron estudios neurológicos?</Label>
                                <Input
                                    type="text"
                                    name="estudiosNeurologicosComentario"
                                    placeholder="Comentario"
                                    value={estudiosNeurologicosComentario || ""}
                                    onChange={e => setEstudiosNeurologicosComentario(e.target.value)}
                                />
                            </FlexBox>
                            <FlexBox>
                                <Label>Diagnóstico</Label>
                                <Input
                                    type="text"
                                    name="estudiosNeurologicosDiagnosticoComentario"
                                    placeholder="Comentario"
                                    value={estudiosNeurologicosDiagnosticoComentario || ""}
                                    onChange={e => setEstudiosNeurologicosDiagnosticoComentario(e.target.value)}
                                />
                            </FlexBox>
                        </FlexColumn>
                        <FlexBox>
                            <Label>¿Tiene tics?</Label>
                            <Input
                                type="text"
                                name="ticsComentario"
                                placeholder="Comentario"
                                value={ticsComentario || ""}
                                onChange={e => setTicsComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Se come las uñas?</Label>
                            <Input
                                type="text"
                                name="uniasComentario"
                                placeholder="Comentario"
                                value={uniasComentario || ""}
                                onChange={e => setUniasComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Escolaridad.respondidas}/${avanceAnamnesis.secciones.Escolaridad.total}`}
                            onClick={(e) => manejarActivo(e, "Escolaridad")}
                        >
                            Escolaridad
                        </Boton>
                    </div>
                    <div> {activo === "Escolaridad" ?
                    <Margen>
                        <div>
                            <FlexBox>
                                <Label>¿Guardería?</Label>

                                <Select
                                    value={infoGuarderia || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setInfoGuarderia(valor);

                                        if (valor !== "Si") {
                                            setGuarderiaEdad("");
                                            setGuarderiaComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>

                            {infoGuarderia === "Si" ?
                                <FlexBox>
                                    <Label>¿A qué edad?</Label>

                                    <Select
                                        value={guarderiaEdad || ""}
                                        onChange={e => setGuarderiaEdad(e.target.value)}
                                    >
                                        <option value="">Edad</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="guarderiaComentario"
                                        placeholder="Comentario"
                                        value={guarderiaComentario || ""}
                                        onChange={e =>
                                            setGuarderiaComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}
                        </div>
                        <FlexColumn>
                            <FlexBox>
                                <Label>¿Jardín infantes?</Label>

                                <Select
                                    value={infoJardin || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setInfoJardin(valor);

                                        if (valor !== "Si") {
                                            setJardinEdad("");
                                            setJardinComentario("");
                                            setJardinIniciacionComentario("");
                                            setJardinAdaptacionComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>

                            {infoJardin === "Si" ?
                                <FlexBox>
                                    <Label>¿A qué edad?</Label>

                                    <Select
                                        value={jardinEdad || ""}
                                        onChange={e => setJardinEdad(e.target.value)}
                                    >
                                        <option value="">Edad</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="jardinComentario"
                                        placeholder="Comentario"
                                        value={jardinComentario || ""}
                                        onChange={e =>
                                            setJardinComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}

                            <FlexBox>
                                <Label>¿Actitud frente a la iniciación?</Label>
                                <Input
                                    type="text"
                                    name="jardinIniciacionComentario"
                                    placeholder="Comentario"
                                    value={jardinIniciacionComentario || ""}
                                    onChange={e =>
                                        setJardinIniciacionComentario(e.target.value)
                                    }
                                />
                            </FlexBox>

                            <FlexBox>
                                <Label>¿Cuánto duró la adaptación?</Label>
                                <Input
                                    type="text"
                                    name="jardinAdaptacionComentario"
                                    placeholder="Comentario"
                                    value={jardinAdaptacionComentario || ""}
                                    onChange={e =>
                                        setJardinAdaptacionComentario(e.target.value)
                                    }
                                />
                            </FlexBox>
                        </FlexColumn>
                        <FlexBox>
                            <Label>¿Repitió algún año?</Label>
                            <Select value={repitioAnio || ""} onChange={e => setRepitioAnio(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="repitioAnioComentario"
                                placeholder="Comentario"
                                value={repitioAnioComentario || ""}
                                onChange={e => setRepitioAnioComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Comentarios docentes</Label>
                            <Input
                                type="text"
                                name="docenteComentario"
                                placeholder="Comentario"
                                value={docenteComentario || ""}
                                onChange={e => setDocenteComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Trastornos de aprendizaje o conducta?</Label>
                            <Input
                                type="text"
                                name="trastornosComentario"
                                placeholder="Comentario"
                                value={trastornosComentario || ""}
                                onChange={e => setTrastornosComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Maestra particular?</Label>
                            <Select value={maestraParticular || ""} onChange={e => setMaestraParticular(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="maestraParticularComentario"
                                placeholder="Comentario"
                                value={maestraParticularComentario || ""}
                                onChange={e => setMaestraParticularComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.VidaSocial.respondidas}/${avanceAnamnesis.secciones.VidaSocial.total}`}
                            onClick={(e) => manejarActivo(e, "VidaSocial")}
                        >
                            Vida Social
                        </Boton>
                    </div>
                    <div> {activo === "VidaSocial" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Tiene amigos?</Label>
                            <Input
                                type="text"
                                name="amigosComentario"
                                placeholder="Comentario"
                                value={amigosComentario || ""}
                                onChange={e => setAmigosComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Juguetes o actividades preferidas?</Label>
                            <Input
                                type="text"
                                name="actividadesPreferidasComentario"
                                placeholder="Comentario"
                                value={actividadesPreferidasComentario || ""}
                                onChange={e => setActividadesPreferidasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Hubo mudanzas?</Label>
                            <Input
                                type="text"
                                name="mudanzasComentario"
                                placeholder="Comentario"
                                value={mudanzasComentario || ""}
                                onChange={e => setMudanzasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Se festeja el cumpleaños?</Label>
                            <Input
                                type="text"
                                name="festejaCumpleaniosComentario"
                                placeholder="Comentario"
                                value={festejaCumpleaniosComentario || ""}
                                onChange={e => setFestejaCumpleaniosComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>En la plaza, ¿Se vincula con otros niños?</Label>
                            <Input
                                type="text"
                                name="vinculaPlazaComentario"
                                placeholder="Comentario"
                                value={vinculaPlazaComentario || ""}
                                onChange={e => setVinculaPlazaComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.RelacionesFamiliares.respondidas}/${avanceAnamnesis.secciones.RelacionesFamiliares.total}`}
                            onClick={(e) => manejarActivo(e, "RelacionesFamiliares")}
                        >
                            Relaciones Familiares
                        </Boton>
                    </div>
                    <div> {activo === "RelacionesFamiliares" ?
                    <Margen>
                        <SubtituloFormulario>
                            Cómo es en relación con
                        </SubtituloFormulario>

                        <FlexBox>
                            <Label>
                                Relación con el padre
                            </Label>

                            <Input
                                type="text"
                                name="relacionPadreComentario"
                                placeholder="Comentario"
                                value={relacionPadreComentario || ""}
                                onChange={e =>
                                    setRelacionPadreComentario(
                                        e.target.value
                                    )
                                }
                            />
                        </FlexBox>

                        <FlexBox>
                            <Label>
                                Relación con la madre
                            </Label>

                            <Input
                                type="text"
                                name="relacionMadreComentario"
                                placeholder="Comentario"
                                value={relacionMadreComentario || ""}
                                onChange={e =>
                                    setRelacionMadreComentario(
                                        e.target.value
                                    )
                                }
                            />
                        </FlexBox>

                        <FlexBox>
                            <Label>
                                Relación con el hermano
                            </Label>

                            <Input
                                type="text"
                                name="relacionHermanoComentario"
                                placeholder="Comentario"
                                value={relacionHermanoComentario || ""}
                                onChange={e =>
                                    setRelacionHermanoComentario(
                                        e.target.value
                                    )
                                }
                            />
                        </FlexBox>

                        <FlexBox>
                            <Label>
                                Relación con la hermana
                            </Label>

                            <Input
                                type="text"
                                name="relacionHermanaComentario"
                                placeholder="Comentario"
                                value={relacionHermanaComentario || ""}
                                onChange={e =>
                                    setRelacionHermanaComentario(
                                        e.target.value
                                    )
                                }
                            />
                        </FlexBox>

                        <FlexBox>
                            <Label>
                                Relación con la pareja
                            </Label>

                            <Input
                                type="text"
                                name="relacionParejaComentario"
                                placeholder="Comentario"
                                value={relacionParejaComentario || ""}
                                onChange={e =>
                                    setRelacionParejaComentario(
                                        e.target.value
                                    )
                                }
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.Sensopercepcion.respondidas}/${avanceAnamnesis.secciones.Sensopercepcion.total}`}
                            onClick={(e) => manejarActivo(e, "Sensopercepcion")}
                        >
                            Sensopercepción
                        </Boton>
                    </div>
                    <div> {activo === "Sensopercepcion" ?
                    <Margen>
                        <FlexBox>
                            <Label>¿Le molestan las etiquetas de ropa?</Label>
                            <Select value={infoEtiquetas || ""} onChange={e => setInfoEtiquetas(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="etiquetasComentario"
                                placeholder="Comentario"
                                value={etiquetasComentario || ""}
                                onChange={e => setEtiquetasComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Le molesta alguna textura?</Label>
                            <Select value={infoTextura || ""} onChange={e => setInfoTextura(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="texturaComentario"
                                placeholder="Comentario"
                                value={texturaComentario || ""}
                                onChange={e => setTexturaComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Tiene sensibilidad frente a los sonidos?</Label>
                            <Select value={infoSonido || ""} onChange={e => setInfoSonido(e.target.value)}>
                                <option></option>
                                <option>Graves</option>
                                <option>Agudos</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="sonidoComentario"
                                placeholder="Comentario"
                                value={sonidoComentario || ""}
                                onChange={e => setSonidoComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>¿Tiene sensibilidad frente al frío o el calor?</Label>
                            <Select value={frioCalor || ""} onChange={e => setFrioCalor(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="frioCalorComentario"
                                placeholder="Comentario"
                                value={frioCalorComentario || ""}
                                onChange={e => setFrioCalorComentario(e.target.value)}
                            />
                        </FlexBox>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    <Fondo>
                    <div>
                        <Boton
                            data-avance={`${avanceAnamnesis.secciones.TerapiasActualesPrevias.respondidas}/${avanceAnamnesis.secciones.TerapiasActualesPrevias.total}`}
                            onClick={(e) => manejarActivo(e, "TerapiasActualesPrevias")}
                        >
                            Terapias actuales o previas
                        </Boton>
                    </div>
                    <div> {activo === "TerapiasActualesPrevias" ?
                    <Margen>
                        <FlexBox>
                            <Label>Madre</Label>
                            <Select value={terapiaMadre || ""} onChange={e => setTerapiaMadre(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="terapiaMadreComentario"
                                placeholder="Comentario"
                                value={terapiaMadreComentario || ""}
                                onChange={e => setTerapiaMadreComentario(e.target.value)}
                            />
                        </FlexBox>
                        <FlexBox>
                            <Label>Padre</Label>
                            <Select value={terapiaPadre || ""} onChange={e => setTerapiaPadre(e.target.value)}>
                                <option></option>
                                <option>Si</option>
                                <option>No</option>
                            </Select>
                            <InputSmall
                                type="text"
                                name="terapiaPadreComentario"
                                placeholder="Comentario"
                                value={terapiaPadreComentario || ""}
                                onChange={e => setTerapiaPadreComentario(e.target.value)}
                            />
                        </FlexBox>
                        <div>
                            <FlexBox>
                                <Label>Orientación a padres</Label>

                                <Select
                                    value={orientacionPadres || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setOrientacionPadres(valor);

                                        if (valor !== "Si") {
                                            setOrientacionPadresCuando("");
                                            setOrientacionPadresComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>

                            {orientacionPadres === "Si" ?
                                <FlexBox>
                                    <Label>¿Hace cuánto?</Label>

                                    <Select
                                        value={orientacionPadresCuando || ""}
                                        onChange={e =>
                                            setOrientacionPadresCuando(e.target.value)
                                        }
                                    >
                                        <option value="">Años</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="orientacionPadresComentario"
                                        placeholder="Comentario"
                                        value={orientacionPadresComentario || ""}
                                        onChange={e =>
                                            setOrientacionPadresComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}
                        </div>
                        <div>
                            <FlexBox>
                                <Label>Terapia familiar</Label>

                                <Select
                                    value={terapiaFamiliar || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setTerapiaFamiliar(valor);

                                        if (valor !== "Si") {
                                            setTerapiaFamiliarCuando("");
                                            setTerapiaFamiliarComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>

                            {terapiaFamiliar === "Si" ?
                                <FlexBox>
                                    <Label>¿Hace cuánto?</Label>

                                    <Select
                                        value={terapiaFamiliarCuando || ""}
                                        onChange={e =>
                                            setTerapiaFamiliarCuando(e.target.value)
                                        }
                                    >
                                        <option value="">Años</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="terapiaFamiliarComentario"
                                        placeholder="Comentario"
                                        value={terapiaFamiliarComentario || ""}
                                        onChange={e =>
                                            setTerapiaFamiliarComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}
                        </div>
                        <div>
                            <FlexBox>
                                <Label>Abuso de sustancias tóxicas</Label>

                                <Select
                                    value={sustanciasToxicas || ""}
                                    onChange={e => {
                                        const valor = e.target.value;

                                        setSustanciasToxicas(valor);

                                        if (valor !== "Si") {
                                            setSustanciasToxicasCuando("");
                                            setSustanciasToxicasComentario("");
                                        }
                                    }}
                                >
                                    <option value=""></option>
                                    <option value="Si">Si</option>
                                    <option value="No">No</option>
                                </Select>
                            </FlexBox>

                            {sustanciasToxicas === "Si" ?
                                <FlexBox>
                                    <Label>¿Hace cuánto?</Label>

                                    <Select
                                        value={sustanciasToxicasCuando || ""}
                                        onChange={e =>
                                            setSustanciasToxicasCuando(e.target.value)
                                        }
                                    >
                                        <option value="">Años</option>

                                        {Array.from({ length: 6 }).map((opt, i) => (
                                            <option
                                                key={i + 1}
                                                value={i + 1}
                                            >
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Select>

                                    <InputSmall
                                        type="text"
                                        name="sustanciasToxicasComentario"
                                        placeholder="Comentario"
                                        value={sustanciasToxicasComentario || ""}
                                        onChange={e =>
                                            setSustanciasToxicasComentario(e.target.value)
                                        }
                                    />
                                </FlexBox>
                            : ""}
                        </div>
                    </Margen>
                    : ""
                    }
                    </div>
                    </Fondo>
                    
                    <BarraAcciones>

                        {/* PDF + ESTADO DEL LOGO */}

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                flexWrap: 'wrap',
                                gap: '14px',
                                marginRight: 'auto'
                            }}
                        >

                            <BotonPdf
                                type="button"
                                onClick={descargarAnamnesisPdf}
                                disabled={descargandoPdf}
                            >
                                {descargandoPdf
                                    ? 'Generando PDF...'
                                    : 'Generar PDF'
                                }
                            </BotonPdf>


                            {
                                logoCargado && (

                                    <div
                                        style={{
                                            fontSize: '12px',
                                            lineHeight: '1.4',
                                            color: '#646464'
                                        }}
                                    >

                                        {
                                            logoConfigurado
                                                ? '✓ Tenés un logo guardado. '
                                                : 'Se usará el logo de YÖGEN. '
                                        }

                                        <Link
                                            to="/escritorio/miperfil"
                                            style={{
                                                color: '#23AAAF',
                                                fontWeight: 700,
                                                textDecoration: 'underline',
                                                marginLeft: '3px'
                                            }}
                                        >
                                            {
                                                logoConfigurado
                                                    ? 'Cambiar en Mi perfil'
                                                    : 'Agregar en Mi perfil'
                                            }
                                        </Link>

                                    </div>

                                )
                            }

                        </div>


                        {/* BOTÓN GRABAR */}

                        <BotonSmall type="submit">
                            Grabar
                        </BotonSmall>

                    </BarraAcciones>

                </FormularioAnamnesis>

                {/* =====================================
                    ENTREVISTA SEMIESTRUCTURADA
                ====================================== */}

                {
                    semiestructuradaVisitada && (

                        <div
                            style={{
                                display:
                                    tipoAnamnesis === 'semiestructurada'
                                        ? 'block'
                                        : 'none'
                            }}
                        >

                            <AnamnesisEntrevista
                                config={config}
                                id_paciente={id_paciente}
                            />

                        </div>

                    )
                }

                {/* =====================================
                    MODAL DE ADENDA OBLIGATORIA
                    ANAMNESIS ESTRUCTURADA
                ====================================== */}
                {
                    informacionPendiente && (

                        <ModalAdendaAnamnesis

                            tipoDocumento="estructurada"

                            guardando={guardandoConAdenda}

                            onCancelar={cancelarAdenda}

                            onConfirmar={confirmarAdenda}

                        />

                    )
                }

            </ContenidoAnamnesis>

        </CuerpoCompleto>
    );
}
 
export default Anamnesis;